(function() {
	'use strict';

	angular
		.module('activaProperties', [
			'ngAnimate', 
			'ngSanitize', 
			'ngResource', 
			'ui.router', 
			'ui.bootstrap', 
			'toastr',
			'firebase',
			'LocalStorageModule',
			'slugifier',
			'pascalprecht.translate',
			'perfect_scrollbar',
			/*'tmh.dynamicLocale',*/
			'tmh.dynamicLocalePreload',
			'ngPhotoswipe',
			'uiGmapgoogle-maps',
			'ngFileUpload',
			'textAngular',
			'angulartics', 
			'angulartics.google.analytics',
			'angulartics.facebook.pixel',
			'btford.markdown'
			]);

})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('SliderController', SliderController);

  /** @ngInject */
  function SliderController(CONFIG, $http, Metas) {
    var vm = this;
    vm.slides = {};
    vm.img_url = CONFIG.static+'img/';
    init();


    function init() {
      Metas.setMetas();
      loadSlider();
    }
    
    function loadSlider() {
      $http.get(CONFIG.api + 'get/file/slider').success(function (slider) {
        vm.slides = slider;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('SlideController', SlideController);

  /** @ngInject */
  function SlideController(CONFIG, $http, Metas, $stateParams, Upload, $timeout, $window) {
    var vm = this;
    vm.slide = {};
    vm.file = {};
    vm.languages = ['es', 'ca', 'en'];
    vm.saving = false;

    init();

    function init() {
      loadSlide();
    }
    
    function loadSlide() {
      $http.get(CONFIG.api + 'get/file/slider').success(function (slider) {
        vm.slide = slider[$stateParams.tipo][$stateParams.id];
        vm.slide.image = CONFIG.static + "img/" + vm.slide.image;
      });
    }

    vm.save = function() {
      vm.saving = true;
      vm.file.upload = Upload.upload({
        url: CONFIG.api + 'cms/slider/' + $stateParams.tipo + "/" + $stateParams.id,
        data: {slide: vm.slide},
        file: vm.file
      });

      vm.file.upload.then(function (response) {
        $timeout(function () {
          vm.file.result = response.data;
          vm.saving = false;
          $window.scrollTo(0, 0);
        });
      }, function (response) {
        if (response.status > 0)
          vm.errorMsg = response.status + ': ' + response.data;
      });
    } 
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('PaginasController', PaginasController);

  /** @ngInject */
  function PaginasController(CONFIG, $http, Metas) {
    var vm = this;
    vm.servicios = [];
    vm.paginas = {
      '775': {
        nid: 775,
        title: 'MENU.QUIENES_SOMOS'
      },
      '2784': {
        nid: 2784,
        title: 'MENU.VENDER_ALQUILAR'
      },
      '2783': {
        nid: 2783,
        title: 'MENU.AGENCIA'
      },
      '2785': {
        nid: 2785,
        title: 'MENU.POLITICA_COOKIES'
      },
      '2786': {
        nid: 2786,
        title: 'MENU.AVISO_LEGAL'
      }
    };
    vm.img_url = CONFIG.static+'img/';

    init();

    function init() {
      Metas.setMetas();
      loadPages();
    }
    
    function loadPages() {
      $http.get(CONFIG.api + 'get/file/titles').success(function (servicios) {
        vm.servicios = servicios;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('PaginaController', PaginaController);

  /** @ngInject */
  function PaginaController(CONFIG, $http, Metas, $stateParams, Upload, $timeout, $window) {
    var vm = this;
    vm.pagina = {};
    vm.file = {};
    vm.languages = ['es', 'ca', 'en'];
    vm.saving = false;

    init();

    function init() {
      Metas.setMetas();
      loadPage();
    }
    
    function loadPage() {
      $http.get(CONFIG.api + 'get/file/pages').success(function (paginas) {
        vm.pagina = paginas[$stateParams.id];
        vm.main_image = CONFIG.static+'img/'+vm.pagina.image;
      });
    }

    vm.save = function() {
      vm.saving = true;
      vm.file.upload = Upload.upload({
        url: CONFIG.api + 'cms/page/'+ $stateParams.id,
        data: {pagina: vm.pagina},
        file: vm.file
      });

      vm.file.upload.then(function (response) {
        $timeout(function () {
          vm.file.result = response.data;
          vm.saving = false;
          $window.scrollTo(0, 0);
        });
      }, function (response) {
        if (response.status > 0)
          vm.errorMsg = response.status + ': ' + response.data;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .factory('Auth', Auth);

  /** @ngInject */
  function Auth($firebaseAuth) {
    return $firebaseAuth();
  }
    
})();
(function () {
  'use strict';

  angular
    .module('activaProperties')
    .factory('translator', translator);

  /** @ngInject */
  function translator($q) {
    return function (options) {

      var deferred = $q.defer();

      var translations = {
        es: {
          MENU: {
            QUIENES_SOMOS: 'Quiénes somos',
            SERVICIOS: 'Servicios',
            DESTACADOS: {
              TITULO: 'Destacados',
              NAVES_DESTACADAS: 'Naves destacadas',
              OFICINAS_DESTACADAS: 'Oficinas destacadas'
            },
            MAPA: 'Buscar por mapa',
            BUSCADOR: {
              TITULO: 'Buscador',
              NAVES_INDUSTRIALES: 'Naves y solares',
              OFICINAS: 'Oficinas',
              LOCALES: 'Locales'
            },
            BLOG: 'Blog',
            CONTACTO: 'Contacto',
            AGENCIA: 'Agencia',
            VENDER_ALQUILAR: '¿Vender o alquilar?',
            POLITICA_COOKIES: 'Política de cookies',
            AVISO_LEGAL: 'Aviso legal',
            LOGIN: 'Acceder',
            LOGOUT: 'Salir'
          },
          MAIN: {
            NAVES_POPULARES_venta: "Naves en venta en {{ situacion }}",
            NAVES_POPULARES_alquiler: "Naves en alquiler en {{ situacion }}",
            OFICINAS_POPULARES: "Oficinas en alquiler en {{ situacion }} {{ subsituacion }}",
            PISOS_POPULARES_venta: " en venta en {{ situacion }}",
            PISOS_POPULARES_alquiler: " en alquiler en {{ situacion }}",
            BUSQUEDAS_POPULARES: "Búsquedas populares"
          },
          HOME: {
            TITULO: 'Consultora Inmobiliaria en Barcelona',
            TITULO_FORM: {
              NAVES: 'Naves industriales y oficinas en venta y alquiler',
              RESIDENCIAL: 'Pisos en venta y alquiler'
            },
            DESCRIPCION: 'Servicios Integrales en Venta y Alquiler de Naves y Oficinas en Barcelona. Asesoramiento para encontrar tu futuro hogar. | Proyectos de Inversión.',
            NAVES_DESTACADAS: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            OFICINAS_DESTACADAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            ULTIMAS_ENTRADAS: 'Últimas novedades',
            VIVIENDAS_DESTACADAS: 'Viviendas destacadas',
            VER_MAS: 'Ver más',
            DESTACADO: 'Destacado',
            SIGUENOS: 'Síguenos',
            NEWSLETTER: {
              TITULO: "No te pierdas nada",
              TEXTO: "Apúntate a nuestra lista de correo y recibe todas nuestras novedades directamente en tu bandeja de entrada",
              BOTON: "¡Únete!"
            }
          },
          CONTACTO: {
            TITULO: 'Contacta con Activa properties',
            TITULO_CORTO: '¿Quieres más información?',
            CONTACTANOS: 'Contáctanos',
            FORM_TITLE: '¿Alguna duda?',
            NOMBRE: 'Nombre',
            EMAIL: 'Email',
            TELEFONO: 'Teléfono',
            REFERENCIA: 'Referencia',
            MENSAJE: 'Mensaje',
            ENVIAR: 'Enviar',
            MENSAJE_RECIBIDO: '¡Mensaje recibido!',
            TERMINOS_Y_CONDICIONES: 'Sus datos serán utilizados para gestionar su consulta. Más información en el <a href="{{url}}" target="_blank" title="Aviso legal">Aviso Legal</a>.',
            ACEPTO_NEWS: 'Deseo recibir comunicaciones comerciales.'
          },
          DESTACADOS: {
            TITULO_NAVES: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            TITULO_OFICINAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            VER_MAS: '@:HOME.VER_MAS',
            DESTACADO: '@:HOME.DESTACADO'
          },
          INMUEBLE_LIST: {
            TITULO_NAVES_VENTA: 'Naves industriales en venta',
            TITULO_NAVES_ALQUILER: 'Naves industriales en alquiler',
            TITULO_OFICINAS_VENTA: 'Oficinas en venta',
            TITULO_OFICINAS_ALQUILER: 'Oficinas en alquiler',
            TITULO_VARIABLE: '{{tipo}} en {{operacion}}',
            TITULO_PISOS_VENTA: 'Viviendas en venta',
            TITULO_PISOS_ALQUILER: 'Viviendas en alquiler',
            DESC_NAVES_VENTA: 'Servicios Integrales en Venta de Naves. Conoce todo lo que Activa Properties puede ofrecerte.',
            DESC_NAVES_ALQUILER: 'Servicios Integrales en Alquiler de Naves. Conoce todo lo que Activa Properties puede ofrecerte.',
            DESC_OFICINAS_VENTA: 'Servicios Integrales en Venta y Alquiler de Oficinas en Barcelona. Conoce todo lo que Activa Properties puede ofrecerte.',
            DESC_OFICINAS_ALQUILER: 'Servicios Integrales en Venta y Alquiler de Oficinas en Barcelona. Conoce todo lo que Activa Properties puede ofrecerte.',
            DESC_PISOS_VENTA: 'Servicios Integrales en Venta de Pisos en Barcelona. Conoce todo lo que Activa Properties puede ofrecerte.',
            DESC_PISOS_ALQUILER: 'Servicios Integrales en Alquiler de Pisos en Barcelona. Conoce todo lo que Activa Properties puede ofrecerte.',
            MOSTRANDO: 'Mostrando',
            RESULTADOS_DE: 'resultados de',
            NO_HAY_RESULTADOS: 'No hay resultados para tu búsqueda.',
            DESTACADO: '@:HOME.DESTACADO',
            VER_MAS: '@:HOME.VER_MAS',
            A_CONSULTAR: 'A consultar',
            ORDEN: {
              TITLE: 'Ordenar por:',
              RELEVANCIA: 'Relevancia',
              PRECIO_M2_ASC: 'm2 más barato',
              PRECIO_M2_DESC: 'm2 más caro',
              PRECIO_ASC: 'Precio más barato',
              PRECIO_DESC: 'Precio más caro',
              SUPERFICIA_ASC: 'Menor superfície',
              SUPERFICIA_DESC: 'Mayor superfície',
              FECHA_PUB_ASC: 'Publicación más reciente',
              FECHA_PUB_DESC: 'Publicación más antigua'
            }
          },
          INMUEBLE_DET: {
            DIRECCION: 'Dirección',
            CARACTERISTICAS: 'Características destacadas',
            CERTIFICACION: 'Certificación energética',
            DE_SUPERFICIE: 'de superficie',
            GENERAL: 'General',
            MES: 'mes',
            VOLVER: 'Volver',
            PRECIO: 'Precio',
            PRECIO_M2: 'Precio m²',
            IMPRIMIR: 'Imprimir',
            PDF: 'Pdf',
            NAVES_RELACIONADAS: 'Naves y solares relacionados',
            OFICINAS_RELACIONADAS: 'Oficinas relacionadas',
            AIRE_ACONDICIONADO: 'Aire acondicionado',
            AMUEBLADO: 'Amueblado',
            ASCENSOR: 'Ascensor',
            CALEFACCION: 'Calefacción',
            PISCINA: 'Piscina',
            HABITACIONES_DOBLES: 'Habitaciones dobles',
            HABITACIONES_SIMPLES: 'Habitaciones simples',
            BANOS: 'Baños',
            META_TITLE: '{{tipo}} en {{operacion}} en {{subsituacion}}. {{situacion}}.',
            META_DESC: '{{tipo}} de {{superficie}}m² en {{operacion}} en {{subsituacion}}. {{situacion}}.'
          },
          BUSCADOR: {
            TITULO: '¡Encuentra lo que buscas!',
            REGIMEN: 'Régimen',
            NAVES: 'Naves industriales',
            PISOS: 'Viviendas',
            OFICINAS: 'Oficinas',
            ALQUILER: 'Alquiler',
            LOCALES: 'Locales',
            VENTA: 'Venta',
            ZONA: 'Zona',
            LOCALIZACION: 'Localización',
            TIPO_INMUEBLE: 'Tipo de inmueble',
            PRECIO: 'Precio',
            DE: 'De',
            HASTA: 'Hasta',
            SUPERFICIE: 'Superficie',
            SERVICIOS: 'Características',
            PROVINCIA: 'Província',
            POBLACION: 'Población',
            NO_HAY_RESULTADOS: 'No hay resultados.',
            BUSCAR: 'Buscar',
            TODAS: 'Todas',
            AREA: 'Área',
            HABITACIONES: 'Habitaciones',
            BANOS: 'Baños',
            O_MAS: 'o más',
            RESET: 'Quitar filtros',
            EN: ' en '
          },
          alquiler: '@:BUSCADOR.ALQUILER',
          venta: '@:BUSCADOR.VENTA',
          nave: 'Nave Industrial',
          oficina: 'Oficina',
          piso: 'Piso'
        },
        ca: {
          MENU: {
            QUIENES_SOMOS: 'Qui som',
            SERVICIOS: 'Serveis',
            DESTACADOS: {
              TITULO: 'Destacats',
              NAVES_DESTACADAS: 'Naus destacades',
              OFICINAS_DESTACADAS: 'Oficines destacades'
            },
            MAPA: 'Cercar per mapa',
            BUSCADOR: {
              TITULO: 'Cercador',
              NAVES_INDUSTRIALES: 'Naus i solars',
              OFICINAS: 'Oficines',
              LOCALES: 'Locals'
            },
            BLOG: 'Blog',
            CONTACTO: 'Contacte',
            AGENCIA: 'Agència',
            VENDER_ALQUILAR: 'Vendre o llogar?',
            POLITICA_COOKIES: 'Política de cookies',
            AVISO_LEGAL: 'Avís legal',
            LOGIN: 'Accedir',
            LOGOUT: 'Sortir'
          },
          MAIN: {
            NAVES_POPULARES_venta: "Nau en venda a {{ situacion }}",
            NAVES_POPULARES_alquiler: "Nau a lloger a {{ situacion }}",
            OFICINAS_POPULARES: "Oficines en lloguer a {{ situacion }} {{ subsituacion }}",
            PISOS_POPULARES_venta: " en venda a {{ situacion }}",
            PISOS_POPULARES_alquiler: " a lloguer a {{ situacion }}",
            BUSQUEDAS_POPULARES: "Cerques populars"
          },
          HOME: {
            TITULO: 'Troba el teu immoble',
            TITULO_FORM: {
              NAVES: 'Naus industrials i oficines en venda i lloguer',
              RESIDENCIAL: 'Pisos en venda i lloguer'
            },
            DESCRIPCION: 'Serveis Integrals en Venda i Lloguer de Naus i Oficines a Barcelona. Assessorament per trobar la teva futura llar. | Projectes d\'Inversió.',
            NAVES_DESTACADAS: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            OFICINAS_DESTACADAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            ULTIMAS_ENTRADAS: 'Ultimes novetats',
            VIVIENDAS_DESTACADAS: 'Vivendes destacades',
            VER_MAS: 'Veure més',
            DESTACADO: 'Destacat',
            SIGUENOS: 'Segueix-nos',
            NEWSLETTER: {
              TITULO: "No et perdis res",
              TEXTO: "Apunta't a la nostra llista de correu i rep totes les nostres novetats directament a la teva bústia d'entrada",
              BOTON: "Uneix-t'hi!"
            }
          },
          CONTACTO: {
            TITULO: 'Contacta amb Activa properties',
            TITULO_CORTO: 'Vols més informació?',
            CONTACTANOS: 'Contacta\'ns',
            FORM_TITLE: '¿Algun dubte?',
            NOMBRE: 'Nom',
            EMAIL: 'Email',
            TELEFONO: 'Telèfon',
            REFERENCIA: 'Referència',
            MENSAJE: 'Missatge',
            ENVIAR: 'Enviar',
            MENSAJE_RECIBIDO: 'Missatge rebut!',
            TERMINOS_Y_CONDICIONES: 'Les seves dades seran usades per gestionar la seva consulta. Més informació a <a href="{{url}}" target="_blank" title="Avís legal">l\'Avís Legal</a>.',
            ACEPTO_NEWS: 'Desitjo rebre comunicacions comercials.'
          },
          DESTACADOS: {
            TITULO_NAVES: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            TITULO_OFICINAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            VER_MAS: '@:HOME.VER_MAS',
            DESTACADO: '@:HOME.DESTACADO'
          },
          INMUEBLE_LIST: {
            TITULO_NAVES_VENTA: 'Naus industrials en venda',
            TITULO_NAVES_ALQUILER: 'Naus industrials a lloguer',
            TITULO_OFICINAS_VENTA: 'Oficines en venda',
            TITULO_OFICINAS_ALQUILER: 'Oficines a lloguer',
            TITULO_VARIABLE: '{{tipo}} en {{operacion}}',
            TITULO_PISOS_VENTA: 'Vivendes en venda',
            TITULO_PISOS_ALQUILER: 'Vivendes a lloguer',
            DESC_NAVES_VENTA: 'Serveis Integrals en Venda de Naus. Coneix tot el que Activa Properties pot oferir-te.',
            DESC_NAVES_ALQUILER: 'Serveis Integrals en Lloguer de Naus. Coneix tot el que Activa Properties pot oferir-te.',
            DESC_OFICINAS_VENTA: 'Serveis Integrals en Venda i Lloguer d\'Oficines a Barcelona. Coneix tot el que Activa Properties pot oferir-te.',
            DESC_OFICINAS_ALQUILER: 'Serveis Integrals en Venda i Lloguer d\'Oficines a Barcelona. Coneix tot el que Activa Properties pot oferir-te.',
            DESC_PISOS_VENTA: 'Serveis Integrals en Venda de Pisos a Barcelona. Coneix tot el que Activa Properties pot oferir-te.',
            DESC_PISOS_ALQUILER: 'Serveis Integrals en Lloguer de Pisos a Barcelona. Coneix tot el que Activa Properties pot oferir-te.',
            MOSTRANDO: 'Mostrant',
            RESULTADOS_DE: 'resultats de',
            NO_HAY_RESULTADOS: 'No hi ha resultats per la teva cerca.',
            DESTACADO: '@:HOME.DESTACADO',
            VER_MAS: '@:HOME.VER_MAS',
            A_CONSULTAR: 'A consultar',
            ORDEN: {
              TITLE: 'Ordenar per:',
              RELEVANCIA: 'Rellevancia',
              PRECIO_M2_ASC: 'm2 més barat',
              PRECIO_M2_DESC: 'm2 més car',
              PRECIO_ASC: 'Precio més barat',
              PRECIO_DESC: 'Precio més car',
              SUPERFICIA_ASC: 'Menor superfície',
              SUPERFICIA_DESC: 'Mayor superfície'
            }
          },
          INMUEBLE_DET: {
            DIRECCION: 'Direcció',
            CARACTERISTICAS: 'Característiques destacades',
            CERTIFICACION: 'Certificació energètica',
            DE_SUPERFICIE: 'de superfície',
            GENERAL: 'General',
            MES: 'mes',
            VOLVER: 'Torna',
            PRECIO: 'Preu',
            PRECIO_M2: 'Preu m²',
            IMPRIMIR: 'Imprimir',
            PDF: 'Pdf',
            NAVES_RELACIONADAS: 'Naus i solars relacionats',
            OFICINAS_RELACIONADAS: 'Oficines relacionades',
            AIRE_ACONDICIONADO: 'Aire acondicionat',
            AMUEBLADO: 'Moblat',
            ASCENSOR: 'Ascensor',
            CALEFACCION: 'Calefacció',
            PISCINA: 'Piscina',
            HABITACIONES_DOBLES: 'Habitacions dobles',
            HABITACIONES_SIMPLES: 'Habitacions simples',
            BANOS: 'Banys',
            META_TITLE: '{{tipo}} en {{operacion}} a {{subsituacion}}. {{situacion}}.',
            META_DESC: '{{tipo}} de {{superficie}}m² en {{operacion}} a {{subsituacion}}. {{situacion}}.'
          },
          BUSCADOR: {
            TITULO: 'Troba el que busques!',
            REGIMEN: 'Règim',
            NAVES: 'Naus industrials',
            PISOS: 'Vivendes',
            OFICINAS: 'Oficines',
            ALQUILER: 'Lloguer',
            LOCALES: 'Locals',
            VENTA: 'Venda',
            ZONA: 'Zona',
            LOCALIZACION: 'Localizació',
            TIPO_INMUEBLE: 'Tipus d\'immoble',
            PRECIO: 'Preu',
            DE: 'De',
            HASTA: 'Fins',
            SUPERFICIE: 'Superfície',
            SERVICIOS: 'Característiques',
            PROVINCIA: 'Província',
            POBLACION: 'Població',
            NO_HAY_RESULTADOS: 'No hi ha resultats.',
            BUSCAR: 'Cercar',
            TODAS: 'Totes',
            AREA: 'Àrea',
            HABITACIONES: 'Habitacions',
            BANOS: 'Banys',
            O_MAS: 'o més',
            RESET: 'Treure filtros',
            EN: ' a '
          },
          alquiler: '@:BUSCADOR.ALQUILER',
          venta: '@:BUSCADOR.VENTA',
          nave: 'Nau Industrial',
          oficina: 'Oficina',
          piso: 'Pis'
        },
        en: {
          MENU: {
            QUIENES_SOMOS: 'Who we are',
            SERVICIOS: 'Services',
            DESTACADOS: {
              TITULO: 'Featured',
              NAVES_DESTACADAS: 'Featured plants',
              OFICINAS_DESTACADAS: 'Featured offices'
            },
            MAPA: 'Search on map',
            BUSCADOR: {
              TITULO: 'Search',
              NAVES_INDUSTRIALES: 'Industrial & solars',
              OFICINAS: 'Offices',
              LOCALES: 'Premises'
            },
            BLOG: 'Blog',
            CONTACTO: 'Contact',
            AGENCIA: 'Agency',
            VENDER_ALQUILAR: 'Sale or rent?',
            POLITICA_COOKIES: 'Cookies policy',
            AVISO_LEGAL: 'Disclaimer',
            LOGIN: 'Login',
            LOGOUT: 'Logout'
          },
          MAIN: {
            NAVES_POPULARES_venta: "Plants on sale in {{ situacion }}",
            NAVES_POPULARES_alquiler: "Plants on rental in {{ situacion }}",
            OFICINAS_POPULARES: "Offices on rental in {{ situacion }} {{ subsituacion }}",
            PISOS_POPULARES_venta: " on sale in {{ situacion }}",
            PISOS_POPULARES_alquiler: " on rent in {{ situacion }}",
            BUSQUEDAS_POPULARES: "Popular searches"
          },
          HOME: {
            TITULO: 'Find your property',
            TITULO_FORM: {
              NAVES: 'Industrial plants and offices for rent and sale',
              RESIDENCIAL: 'Apartments for rent and sale'
            },
            DESCRIPCION: 'Comprehensive Services in Sale and Rent of Plants and Offices in Barcelona. Advice to find your future home. | Investment projects.',
            NAVES_DESTACADAS: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            OFICINAS_DESTACADAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            ULTIMAS_ENTRADAS: 'Latest news',
            VIVIENDAS_DESTACADAS: 'Featured flats',
            VER_MAS: 'See more',
            DESTACADO: 'Featured',
            SIGUENOS: 'Follow us',
            NEWSLETTER: {
              TITULO: "Don't miss anything",
              TEXTO: "Join to our mailing list to recieve all our latest news right into your inbox",
              BOTON: "Join in!"
            }
          },
          CONTACTO: {
            TITULO: 'Contact with Activa properties',
            TITULO_CORTO: '¿Need more information?',
            CONTACTANOS: 'Contact us',
            FORM_TITLE: 'Any questions?',
            NOMBRE: 'Name',
            EMAIL: 'Email',
            TELEFONO: 'Phone',
            REFERENCIA: 'Reference',
            MENSAJE: 'Message',
            ENVIAR: 'Send',
            MENSAJE_RECIBIDO: 'Message sent!',
            TERMINOS_Y_CONDICIONES: 'Your data will be used to manage your query. More information in the <a href="{{url}}" target="_blank" title="Legal Advice">Legal Advice</a>.',
            ACEPTO_NEWS: 'I wish to receive commercial communications.'
          },
          DESTACADOS: {
            TITULO_NAVES: '@:MENU.DESTACADOS.NAVES_DESTACADAS',
            TITULO_OFICINAS: '@:MENU.DESTACADOS.OFICINAS_DESTACADAS',
            VER_MAS: '@:HOME.VER_MAS',
            DESTACADO: '@:HOME.DESTACADO'
          },
          INMUEBLE_LIST: {
            TITULO_NAVES_VENTA: 'Industrial plants on sale',
            TITULO_NAVES_ALQUILER: 'Industrial plants on rent',
            TITULO_OFICINAS_VENTA: 'Offices on sale',
            TITULO_OFICINAS_ALQUILER: 'Offices on rent',
            TITULO_VARIABLE: '{{tipo}} on {{operacion}}',
            TITULO_PISOS_VENTA: 'Apartments on sale',
            TITULO_PISOS_ALQUILER: 'Apartments on rent',
            DESC_NAVES_VENTA: 'Comprehensive Services in Sale of Plants. Advice all what Activa Properties can offer you.',
            DESC_NAVES_ALQUILER: 'Comprehensive Services in Rent of Plants. Advice all what Activa Properties can offer you.',
            DESC_OFICINAS_VENTA: 'Comprehensive Services in Sale and Rent of Offices in Barcelona. Advice all what Activa Properties can offer you.',
            DESC_OFICINAS_ALQUILER: 'Comprehensive Services in Sale and Rent of Offices in Barcelona. Advice all what Activa Properties can offer you.',
            DESC_PISOS_VENTA: 'Comprehensive Services in Sale of Apartments in Barcelona. Advice all what Activa Properties can offer you.',
            DESC_PISOS_ALQUILER: 'Comprehensive Services in Rent of Apartments in Barcelona. Advice all what Activa Properties can offer you.',
            MOSTRANDO: 'Showing',
            RESULTADOS_DE: 'results of',
            NO_HAY_RESULTADOS: 'No results for this search.',
            DESTACADO: '@:HOME.DESTACADO',
            VER_MAS: '@:HOME.VER_MAS',
            A_CONSULTAR: 'To consult',
            ORDEN: {
              TITLE: 'Sort by:',
              RELEVANCIA: 'Relevance',
              PRECIO_M2_ASC: 'm2 price lower',
              PRECIO_M2_DESC: 'm2 higher',
              PRECIO_ASC: 'Price lower',
              PRECIO_DESC: 'Price higher',
              SUPERFICIA_ASC: 'Less surface',
              SUPERFICIA_DESC: 'More surface'
            }
          },
          INMUEBLE_DET: {
            DIRECCION: 'Address',
            CARACTERISTICAS: 'Product highlights',
            CERTIFICACION: 'Energy Performance Certification',
            DE_SUPERFICIE: 'of surface',
            GENERAL: 'General',
            MES: 'month',
            VOLVER: 'Go back',
            PRECIO: 'Price',
            PRECIO_M2: 'Price m²',
            IMPRIMIR: 'Print',
            PDF: 'Pdf',
            NAVES_RELACIONADAS: 'Related industrials & solars',
            OFICINAS_RELACIONADAS: 'Related offices',
            AIRE_ACONDICIONADO: 'Air conditioning',
            AMUEBLADO: 'Furnished',
            ASCENSOR: 'Elevator',
            CALEFACCION: 'Heating',
            PISCINA: 'Swimming pool',
            HABITACIONES_DOBLES: 'Double rooms',
            HABITACIONES_SIMPLES: 'Single rooms',
            BANOS: 'Bathrooms',
            META_TITLE: '{{tipo}} on {{operacion}} in {{subsituacion}}. {{situacion}}.',
            META_DESC: '{{tipo}} of {{superficie}}m² on {{operacion}} at {{subsituacion}}. {{situacion}}.'
          },
          BUSCADOR: {
            TITULO: 'Find what you are searching for!',
            REGIMEN: 'Regime',
            NAVES: 'Industrial plants',
            OFICINAS: 'Offices',
            PISOS: 'Apartments',
            LOCALES: 'Premises',
            ALQUILER: 'Rent',
            VENTA: 'Sale',
            ZONA: 'Zone',
            LOCALIZACION: 'Localization',
            TIPO_INMUEBLE: 'Property type',
            PRECIO: 'Price',
            DE: 'From',
            HASTA: 'To',
            SUPERFICIE: 'Surface',
            SERVICIOS: 'Features',
            PROVINCIA: 'Province',
            POBLACION: 'Town',
            NO_HAY_RESULTADOS: 'No results.',
            BUSCAR: 'Search',
            TODAS: 'All',
            AREA: 'Area',
            HABITACIONES: 'Rooms',
            BANOS: 'Bathrooms',
            O_MAS: 'or more',
            RESET: 'Remove filters',
            EN: ' in '
          },
          alquiler: '@:BUSCADOR.ALQUILER',
          venta: '@:BUSCADOR.VENTA',
          nave: 'Industrial Plant',
          oficina: 'Office',
          piso: 'Flat'
        }
      };
      deferred.resolve(translations[options.key]);

      return deferred.promise;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .factory('Sidebars', Sidebars);

  /** @ngInject */
  function Sidebars() {
    var srv = this;

    srv.sidebarOpen = 'none';
    srv.toggleSidebar = toggleSidebar;
    
    function toggleSidebar (side) 
    {
      if(srv.sidebarOpen === side) {
        srv.sidebarOpen = 'none';
      } else {
        srv.sidebarOpen = side;
      }
    }

    return srv;

  }
    
})();
(function () {
    'use strict';

    angular
        .module('activaProperties')
        .service('MiniBuscador', MiniBuscador);

    /** @ngInject */
    function MiniBuscador(RESIDENCIAL, $translate, Inmuebles, $state) {
        var self = this;

        self.isResidencial = RESIDENCIAL;

        self.operaciones = [
            { value: 'alquiler', title: $translate.instant('BUSCADOR.ALQUILER') },
            { value: 'venta', title: $translate.instant('BUSCADOR.VENTA') }
        ];

        self.tipos = [
            { value: 'naves', title: $translate.instant('BUSCADOR.NAVES') },
            { value: 'oficinas', title: $translate.instant('BUSCADOR.OFICINAS') },
            { value: 'locales', title: $translate.instant('BUSCADOR.LOCALES') }
        ];

        if (self.isResidencial) {
            self.tipos = [
                { value: 'pisos', title: $translate.instant('BUSCADOR.PISOS') }
            ];
        }

        //self.situaciones = Inmuebles.situaciones;

        self.params = {
            operacion: self.operaciones[0].value,
            tipo: self.tipos[0].value
        }

        self.fireSearch = function () {
            $state.go('buscador', self.params);
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('activaProperties')
    .factory('Page', Page);

  /** @ngInject */
  function Page($log, $http, $translate, CONFIG) {
    return {
      page: {},
      getPage: function(nid) {
        //var promise = $http.jsonp(CONFIG.api+$translate.use()+'/page/'+nid+'?callback=JSON_CALLBACK').then(function (response) {
        var promise = $http.get(CONFIG.api+'page/'+$translate.use()+'/'+nid).then(function (response) {
          if(response.data.length===0) {
            Page.page = {
              title: 'Página no encontrada',
              body: '<p>Algo ha ido mal! No hemos encontrado la página que estás buscando.</p>'
            };
          } else {
            Page.page = {
              title: response.data.title,
              body: response.data.body,
              image: response.data.image
            }
          }
          return Page.page;
        });
        return promise;
      },
      getPages: function() {
        //var promise = $http.jsonp(CONFIG.api+$translate.use()+'/pages/'+cat+'?callback=JSON_CALLBACK', {ignoreLoadingBar: true}).then(function (response) {
        //var promise = $http.get(CONFIG.api+'titles.json', {ignoreLoadingBar: true}).then(function (response) {
        var promise = $http.get(CONFIG.api+'get/file/titles', {ignoreLoadingBar: true}).then(function (response) {
          Page.page = response.data;
          return Page.page;
        });
        return promise;
      }
    }
  }
    
})();
(function() {
    'use strict';

    angular
        .module('activaProperties')
        .factory('Metas', Metas);

    /** @ngInject */
    function Metas($translate, $filter, $rootScope, $location, CONFIG, $window) {
        var metas = {
            setTitle: setTitle,
            setDescription: setDescription,
            setMetas: setMetas
        };
        $rootScope.og = {};
        $rootScope.og.image = { src: '', size: {} };

        function setTitle(title) {
            title = title || $translate.instant("HOME.TITULO");
            $rootScope.og.title = title;
            $rootScope.metaTitle = title + " | ACTIVA PROPERTIES";
        }

        function setDescription(description) {
            description = description || $translate.instant("HOME.DESCRIPCION");
            description = String(description).replace(/<[^>]+>/gm, '');
            description = (description.length <= 150) ? description : $filter('limitTo')(description, 150, 0);
            $rootScope.metaDescription = description;
            $rootScope.og.description = description;
        }

        function setImage(image) {
            $rootScope.og.url = $location.absUrl();
            image = image || 'img/1.jpg';
            $rootScope.og.image.src = /*CONFIG.static +*/ image;
            setImageSize();
        }

        function setImageSize() {
            var img = new Image();
            img.onload = function() {
                $rootScope.og.image.size = { width: this.width, height: this.height };
                $window.prerenderReady = true;
            }
            img.src = $rootScope.og.image.src;
        }

        function setType(type) {
            $rootScope.og.type = type || 'website';
        }

        function setMetas(title, description, image, type) {
            setTitle(title);
            setDescription(description);
            setImage(image);
            setType(type);
        }

        return metas;

    }

})();
(function() {
    'use strict';

    /*
    TODO: Treballar nomes amb el tipus d'inmoble necessari (naus o oficines)
    */
    angular
        .module('activaProperties')
        .service('Inmuebles', Inmuebles);

    /** @ngInject */
    function Inmuebles($log, $filter, $http, $rootScope, $q, CONFIG, RESIDENCIAL) {
        var self = this;

        var inmuebles = {};
        self.situaciones = {};
        self.subtipos = {};
        self.servicios = {};

        self.loaded = false;
        self.referencias = {};
        self.naves = [];
        self.oficinas = [];
        self.pisos = [];
        self.locals = [];
        self.filters = {};
        self.order = {};
        self.arrayFilters = {
            subsituacion: [],
            servicios: []
        };
        self.rangeFilters = {
            superficie_min: '',
            superficie_max: '',
            precio_min: '',
            precio_max: ''
        };
        self.sharedVars = {};
        self.loadInmuebles = loadInmuebles;
        self.getInmueble = getInmueble;
        self.setFilters = setFilters;
        self.setOrder = setOrder;
        self.setArrayFilters = setArrayFilters;
        self.setRangeFilters = setRangeFilters;
        //self.getReferencias = getReferencias;
        self.setSharedVar = setSharedVar;

        var tipos = [];
        if (RESIDENCIAL) {
            tipos = ["pisos"];
        } else {
            tipos = ["naves", "oficinas", "locals"];
        }


        function loadInmuebles() {
            var init = new Date();

            var promises = {
                //inmuebles: $http.get(CONFIG.api + 'get/file/inmuebles'),
                //naves: $http.get(CONFIG.api + 'get/file/naves'),
                //oficinas: $http.get(CONFIG.api + 'get/file/oficinas'),
                //pisos: $http.get(CONFIG.api + 'get/file/pisos'),
                situaciones: $http.get(CONFIG.api + 'get/file/situaciones'),
                subsituaciones: $http.get(CONFIG.api + 'get/file/subsituaciones'),
                subtipos: $http.get(CONFIG.api + 'get/file/subtipos'),
                servicios: $http.get(CONFIG.api + 'get/file/servicios')
            }
            if (RESIDENCIAL) {
                promises.pisos = $http.get(CONFIG.api + 'get/file/pisos');
            } else {
                promises.naves = $http.get(CONFIG.api + 'get/file/naves');
                promises.oficinas = $http.get(CONFIG.api + 'get/file/oficinas');
                promises.locals = $http.get(CONFIG.api + 'get/file/locals');
            }

            return $q.all(promises).then(function(result) {
                if (RESIDENCIAL) {
                    self.pisosOriginal = [];
                    self.pisos = [];
                    inmuebles.pisos = [];
                    angular.forEach(result.pisos.data, function(piso) {
                        self.pisosOriginal.push(piso);
                        self.pisos.push(piso);
                        inmuebles.pisos.push(piso)
                    });
                } else {
                    self.navesOriginal = [];
                    self.naves = [];
                    inmuebles.naves = [];
                    angular.forEach(result.naves.data, function(nave) {
                        self.naves.push(nave);
                        self.navesOriginal.push(nave);
                        inmuebles.naves.push(nave)
                    });
                    //self.naves = angular.copy(self.navesOriginal);
                    self.oficinasOriginal = [];
                    self.oficinas = [];
                    inmuebles.oficinas = [];
                    angular.forEach(result.oficinas.data, function(oficina) {
                        self.oficinasOriginal.push(oficina);
                        self.oficinas.push(oficina);
                        inmuebles.oficinas.push(oficina)
                    });
                    self.localsOriginal = [];
                    self.locals = [];
                    inmuebles.locals = [];
                    angular.forEach(result.locals.data, function(local) {
                        self.locals.push(local);
                        self.localsOriginal.push(local);
                        inmuebles.locals.push(local)
                    });
                }
                self.situaciones = result.situaciones.data;
                self.subsituaciones = result.subsituaciones.data;
                self.subtipos = result.subtipos.data;
                self.servicios = result.servicios.data;
                var time = new Date() - init;
                $log.debug('Json: ' + (time / 1000) + ' segons');
            }, function() {
            });
        }

        function getInmueble(referencia) {
            return firebase.database().ref('/' + CONFIG.env + '/inmuebles/' + referencia).once('value').then(function(snapshot) {
                var inmueble = snapshot.val();
                inmueble.imagen_principal = {};
                inmueble.imagen_principal.src = /*CONFIG.static +*/ inmueble.imagen;
                if (inmueble.galeria[0].alt.length !== 0) {
                    inmueble.imagen_principal.alt = inmueble.galeria[0].alt;
                } else {
                    inmueble.imagen_principal.alt = $filter('capitalize')(inmueble.title);
                }
                //inmueble.imagen_principal = CONFIG.static + inmueble.imagen;
                return inmueble;
            });
        }

        function setFilters(new_filters) {
            self.filters = new_filters;
            filterInmuebles();
            filterInmueblesByArray();
            filterInmueblesByRange();
            getReferencias();
            $rootScope.$broadcast('filtersChanged');
        }

        function setOrder(new_order) {
            self.order = new_order;
            angular.forEach(tipos, function(tipo) {
                self[tipo] = $filter('orderBy')(self[tipo], self.order.sort_by, self.order.reverse);
            });
        }

        function setArrayFilters(new_filters) {
            self.arrayFilters = new_filters;
            filterInmuebles();
            filterInmueblesByArray();
            filterInmueblesByRange();
            getReferencias();
        }

        function setRangeFilters(new_filters) {
            self.rangeFilters = new_filters;
            filterInmuebles();
            filterInmueblesByArray();
            filterInmueblesByRange();
            getReferencias();
        }

        function setSharedVar(s_var) {
            self.sharedVars = s_var;
        }

        function filterInmuebles() {
            angular.forEach(tipos, function(tipo) {
                self[tipo] = $filter('filter')(inmuebles[tipo], self.filters);
            });
        }

        function filterInmueblesByArray() {
            angular.forEach(tipos, function(tipo) {
                self[tipo] = self[tipo].filter(function(item) {
                    var subsituacion = true;
                    var servicios = true;
                    //subsituacion
                    if (self.arrayFilters.subsituacion.length > 0) {
                        subsituacion = self.arrayFilters.subsituacion.indexOf(item.subsituacion) !== -1;
                    }
                    //servicios
                    if (self.arrayFilters.servicios.length > 0) {
                        var servArr = [self.arrayFilters.servicios, item.servicios];
                        var servRes = servArr.shift().filter(function(v) {
                            return servArr.every(function(a) {
                                if (a === false) {
                                    return false;
                                } else {
                                    return a.indexOf(v) !== -1;
                                }
                            });
                        });
                        servicios = self.arrayFilters.servicios.length === servRes.length;
                    }
                    return subsituacion && servicios;
                });
            });
        }

        function filterInmueblesByRange() {
            angular.forEach(tipos, function(tipo) {
                self[tipo] = $filter('range')(self[tipo], 'superficie', self.rangeFilters.superficie_min, self.rangeFilters.superficie_max);
                self[tipo] = $filter('range')(self[tipo], 'precio', self.rangeFilters.precio_min, self.rangeFilters.precio_max);
                if (tipo === 'pisos') {
                    self[tipo] = $filter('range')(self[tipo], 'habitaciones', self.rangeFilters.habitaciones_min || 0, 50);
                    self[tipo] = $filter('range')(self[tipo], 'banos', self.rangeFilters.banos_min || 0, 50);
                }
            });
        }

        function getReferencias() {
            self.referencias = {};
            angular.forEach(tipos, function(tipo) {
                self.referencias[tipo] = self[tipo].map(function(elem) {
                    return elem.referencia;
                });
            });
        }

    }
})();
(function() {
  'use strict';

  angular
    .module('activaProperties')
    .filter('range', range);

  /** @ngInject */
  function range() {
    return function (items, attr, min, max) {
      var range = [];
      min = (min==='') ? 0 : parseFloat(min);
      max = (max==='') ? 0 : parseFloat(max);
      if(min===0&&max===0){
        return items;
      }
      for (var i=0, l=items.length; i<l; ++i){
        var item = items[i];
        if(item[attr]<=max && item[attr]>=min){
            range.push(item);
        }
      }
      return range;
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .filter('isEmpty', isEmpty);

    /** @ngInject */
    function isEmpty() {
        return function (object) {
            return angular.equals({}, object);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .filter('intersect', intersect);

  /** @ngInject */
  function intersect($log, Inmuebles) {
    return function(arr1, tipo){
      $log.debug(arr1);
      return arr1.filter(function(n) {
        return Inmuebles.referencias[tipo].indexOf(n) != -1
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .filter('destacados', destacados);

  /** @ngInject */
  function destacados(input, $log) {
    return function(input) {
      input = input || {};
      var out = {};
      angular.forEach(input, function(key, value) {
        $log.debug(value);
      });
      return out;
    };  
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .filter('capitalize', capitalize);

  /** @ngInject */
  function capitalize() {
    return function(input) {
      input = input || "";
      var out = "";
      out = input.replace(/([^\W_]+[^\s-]*) */g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      })
      return out;
    };  
  }
})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('share', share);

    /** @ngInject */
    function share() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/directives/share/share.html',
            scope: {
                referencia: '='
            },
            controller: ShareController,
            controllerAs: 'share',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ShareController($window, $document, $uibModal, CONFIG) {
            var vm = this;
            vm.share = share;

            function share(network) {
                var url = "";
                var location = $window.location.href;
                //DEV
                //location = location.replace("http://localhost:3000", "https://activaproperties.com");

                if (network == 'facebook') {
                    url = 'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location) +
                        '&t=' + encodeURIComponent($document[0].title);
                } else if (network == 'twitter') {
                    url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent($document[0].title)+
                        '&url=' + encodeURIComponent(location);
                } else if (network == 'linkedin') {
                    url = 'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(location) + '&token=&isFramed=true';
                }
                $window.open(url, '', 'width=400&height=200');
            }
            vm.share_email = function () {
                $uibModal.open({
                    templateUrl: 'app/main/inmuebles/share.modal.html',
                    controller: function (referencia, $http, $translate, $uibModalInstance) {
                        var modal = this;
                        modal.contactAlerts = [];
                        modal.referencia = referencia;
                        modal.sending = false;
                        modal.params = {
                            from_name: '',
                            from_email: '',
                            to_name: '',
                            to_email: '',
                            message: '',
                            url: $window.location.href,
                            ref: referencia
                        }

                        modal.enviar = function () {
                            modal.sending = true;
                            $http.post(CONFIG.api + 'mail/send/share', modal.params).then(function () {
                                $translate('CONTACTO.MENSAJE_RECIBIDO').then(function (mensaje_ok) {
                                    modal.contactAlerts.push({ type: 'success', msg: mensaje_ok });
                                    modal.sending = false;
                                });
                            }, function (response) {
                                modal.contactAlerts.push({ type: 'danger', msg: response.data.message });
                                modal.sending = false;
                            });
                            //$uibModalInstance.close();
                        };

                        modal.closeAlert = function (index) {
                            modal.contactAlerts.splice(index, 1);
                        };

                        modal.cancelar = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    },
                    controllerAs: 'modal',
                    resolve: {
                        referencia: function () {
                            return vm.referencia;
                        }
                    }
                });
            }

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('pageHeader', pageHeader);

    /** @ngInject */
    function pageHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/directives/pageHeader/pageHeader.html',
            scope: {
                image: '=',
                title: '=',
                inmueble: '='
            }
        };

        return directive;
    }

})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directives/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'nav',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(Page, $scope, $state, $stateParams, RESIDENCIAL, CONFIG, Sidebars, $document, $window, $location) {
      var vm = this;
      vm.state = $state;
      vm.locale = $stateParams.locale;
      vm.sidebars = Sidebars;
      vm.residencial = RESIDENCIAL;
      vm.navCollapsed = true;
      vm.menuActive = false;
      vm.toggleCollapsed = toggleCollapsed;
      vm.switchLang = switchLang;
      
      getServicios();
      initScrollSpy();
      closeMenuHandlers();

      if(RESIDENCIAL) {
        vm.changePortalUrl = CONFIG.domain_activa;
      } else {
        vm.changePortalUrl = CONFIG.domain_residencial;
      }
      
      function closeMenuHandlers() {
        $document.on('scroll', function () {
          if (!vm.navCollapsed) {
            $scope.$apply(function () {
              vm.navCollapsed = true;
            });
          }
        });
        $document.on('click', function (e) {
          var headerElm = $document[0].getElementById('hidden-menu');
          if (!vm.navCollapsed && !headerElm.contains(e.target)) {
            $scope.$apply(function () {
              vm.navCollapsed = true;
            });
            return $document.off('click', event);
          }
        });
        $scope.$on('$locationChangeStart', function () {
          vm.navCollapsed = true;
        });
      }

      function initScrollSpy() {
        $document.on('scroll', function () {
          if ($window.scrollY > 200 && vm.menuActive == false) {
            $scope.$apply(function () {
              vm.menuActive = true;
            });
          } else if ($window.scrollY < 200 && vm.menuActive == true) {
            $scope.$apply(function () {
              vm.menuActive = false;
            });
          }
        });
      }

      function getServicios() {
        Page.getPages(1966).then(function(servicios){
          vm.servicios = servicios;
        });
      }

      function toggleCollapsed() {
        vm.navCollapsed = !vm.navCollapsed;
      }

      function switchLang(langKey) {
        var params = angular.copy($stateParams);
        params.locale = langKey;
        $location.path($state.href($state.current.name, params));
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .directive('miniBuscador', miniBuscador);

  /** @ngInject */
  function miniBuscador() {
    var directive = {
      restrict: 'E',
      scope: {
        title: '=?',
        type: '=?'
      },
      templateUrl: function (elm, attrs) {
        var template = attrs.type || "form";
        return 'app/components/directives/miniBuscador/miniBuscador.' + template + '.html';
      },
      controller: MiniBuscadorController,
      controllerAs: 'mini'
    };
      
    return directive;

    /** @ngInject */
    function MiniBuscadorController($uibModal, MiniBuscador) {
      var vm = this;
      vm.srv = MiniBuscador;
      vm.formClasses = vm.srv.isResidencial ? "col-sm-6 col-md-4" : "col-sm-4 col-md-4";
      vm.openModal = function() {
        $uibModal.open({
          templateUrl: 'app/components/directives/miniBuscador/miniBuscador.modal.html',
          controller: function ($uibModalInstance, MiniBuscador, $translate) {
            var vm = this;
            vm.title = $translate.instant('BUSCADOR.TITULO')
            vm.srv = MiniBuscador;
            
            vm.cancelar = function () {
              $uibModalInstance.dismiss('cancel');
            };
          
          },
          controllerAs: 'mini'
        })
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .directive('descriptionFormat', descriptionFormat);

  /** @ngInject */
  function descriptionFormat() {
    return {
      restrict: 'A',
      scope: {
        descriptionFormat: '@'
      },
      link: function(scope, element) {
        var newDesc = scope.descriptionFormat;
        
        //<p>
        //newDesc = newDesc.replace(/([\.\:]+[ ])+([A-Z])/g,"$1</p><p>$2");
        //newDesc = "<p>"+newDesc+"</p>";

        //<br>
        newDesc = newDesc.replace(/([\.\:]+[ ])+([A-Z])/g,"$1<br>$2");
        element.html(newDesc);
      }
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('contact', contact);

    /** @ngInject */
    function contact() {
        
        var directive = {
            restrict: 'E',
            templateUrl: function(elm, attrs) {
                var template = attrs.type || "default";
                return 'app/components/directives/contact/contact.'+template+'.html'
            },
            scope: {
                referencia: '=?',
                title: '=?',
                type: '=?'
            },
            controller: ContactController,
            controllerAs: 'contact',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ContactController($stateParams, $uibModal, CONFIG, $translate) {
            var vm = this;
            vm.openModal = openModal;
            vm.title = angular.isDefined(vm.title) ? vm.title : $translate.instant('CONTACTO.FORM_TITLE');
            function openModal() {
                $uibModal.open({
                    templateUrl: 'app/components/directives/contact/contact.modal.html',
                    controller: function (referencia, nid, title, $http, $translate, $uibModalInstance, $state, $analytics, $location) {
                        var modal = this;
                        modal.referencia = referencia || false;
                        modal.title = title;
                        var type = 'contact';
                        modal.contact = {
                            nom: '',
                            email: '',
                            telefon: '',
                            missatge: '',
                            id: '',
                            agreement: false,
                            url: $location.absUrl()
                        };

                        if (modal.referencia) {
                            modal.contact.ref = modal.referencia;
                            type = 'property';
                        }
                        modal.contactAlerts = [];
                        modal.terms_link = $state.href('static', { nid: 2786 });

                        modal.submitForm = function () {
                            $http.post(CONFIG.api + 'mail/send/' + type, modal.contact).then(function () {
                                $translate('CONTACTO.MENSAJE_RECIBIDO').then(function (mensaje_ok) {
                                    modal.contactAlerts.push({ type: 'success', msg: mensaje_ok });
                                });
                                $analytics.eventTrack('Lead', {
                                    value: 10.00,
                                    currency: 'USD'
                                });
                            }, function (response) {
                                modal.contactAlerts.push({ type: 'danger', msg: response.data.message });
                            });
                        };
                        modal.closeAlert = function (index) {
                            modal.contactAlerts.splice(index, 1);
                        };

                        modal.cancelar = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    },
                    controllerAs: 'modal',
                    resolve: {
                        referencia: function () {
                            return vm.referencia || $stateParams.referencia;
                        },
                        nid: function () {
                            return vm.nid;
                        },
                        title: function () {
                            return vm.title;
                        }
                    }
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('busquedasRelacionadas', busquedasRelacionadas);

    /** @ngInject */
    function busquedasRelacionadas() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/directives/busquedas-relacionadas/busquedas-relacionadas.html',
            controller: busquedasRelacionadasController,
            controllerAs: 'rel'
        };

        return directive;

        /** @ngInject */
        function busquedasRelacionadasController(Inmuebles, $state, $stateParams, $scope, $rootScope) {
            var vm = this;

            vm.filters = { 
                "operacion": "",
                "situacion": "",
                "subtipo": ""
            };
            getStateParams();
            vm.arrayFilters = Inmuebles.arrayFilters; 
            vm.goToPage = goToPage;
            vm.stateParams = $stateParams;
            vm.links = [];
            
            generateLinks(vm.filters);
            
            var filtersChangedEvent = $rootScope.$on('filtersChanged',
                function () {
                    generateLinks(vm.filters);
                });
            $rootScope.$on('$destroy', filtersChangedEvent);

            function getStateParams() {
                vm.filters.operacion = $stateParams.operacion || "";
                vm.filters.situacion = $stateParams.situacion || "";
                vm.filters.subtipo = $stateParams.subtipo || "";
            }
            function generateLinks(filters) {
                vm.lang = $stateParams.locale;
                var tipo = $stateParams.tipo.slice(0, -1);
                vm.links = [];
                
                if(filters.subtipo !== "") {
                    angular.forEach(Inmuebles.servicios[tipo], function (servicio) {
                        vm.links.push({ tipo: tipo, operacion: filters.operacion, situacion: Inmuebles.situaciones[tipo][filters.situacion], subtipo: Inmuebles.subtipos[tipo][filters.subtipo], servicios: servicio });
                    })
                } else if (filters.situacion !== "") {
                    angular.forEach(Inmuebles.subtipos[tipo], function (subtipo) {
                        vm.links.push({ tipo: tipo, operacion: filters.operacion, situacion: Inmuebles.situaciones[tipo][filters.situacion], subtipo: subtipo, servicios: {id:''} });
                    })
                } else {
                    angular.forEach(Inmuebles.situaciones[tipo], function(situacion) {
                        vm.links.push({ tipo: tipo, operacion: filters.operacion, situacion: situacion, subtipo: '', servicios: {id:''} });
                    })
                }
                // vm.operacion = vm.filters.operacion;
                // vm.subtipos = {};
                // vm.situacion = Inmuebles.filters.situacion ? Inmuebles.situaciones.nave[Inmuebles.filters.situacion] : Inmuebles.situaciones.nave['barcelona-valles-occidental'];
                // var inmuebles = Inmuebles[$stateParams.tipo];
                // for (var i = 0; i < inmuebles.length; i++) {
                //     var inmueble = inmuebles[i];
                //     vm.subtipos[inmueble.subtipo] = Inmuebles.subtipos[$stateParams.tipo.slice(0, -1)][inmueble.subtipo];
                // }
            }

            function goToPage(params) {
                $state.go('buscador', params, { reload: true });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('busquedasPopulares', busquedasPopulares);

    /** @ngInject */
    function busquedasPopulares() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/directives/busquedas-populares/busquedas-populares.html',
            controller: busquedasPopularesController,
            controllerAs: 'pop'
        };

        return directive;

        /** @ngInject */
        function busquedasPopularesController(Inmuebles, RESIDENCIAL, $stateParams) {
            var vm = this;
            vm.isResidencial = RESIDENCIAL;
            vm.locale = $stateParams.locale;
            vm.situacionesNaves = Inmuebles.situaciones.nave;
            vm.situacionesOficinas = Inmuebles.situaciones.oficina;
            vm.subsituacionesOficinas = Inmuebles.subsituaciones.oficina;
            vm.situacionesPisos = Inmuebles.situaciones.piso;
            vm.subtiposPisos = Inmuebles.subtipos.piso;
            
            vm.navesSeleccionadas = [
                'barcelona-valles-occidental',
                'barcelona-baix-llobregat-sud',
                'baix-llobregat-nord',
                'valles-oriental',
                'tarragona',
                'penedes-anoia-bages'
            ];
            vm.oficinasSeleccionadas = [
                [ 'barcelona', '22' ],
                [ 'barcelona', 'centro' ],
                [ 'l-hospitalet-de-llobregat', 'placa-europa' ]
            ];
            vm.pisosSeleccionados = [
                'barcelona'
            ];
            vm.operaciones = ["alquiler", "venta"];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('activaProperties')
        .directive('buscador', buscador);      
    
    /** @ngInject */
    function buscador() {

        var directive = {
            restrict: 'E',
            //templateUrl:  'app/components/directives/buscador/buscador.html',
            templateUrl: function (elm, attrs) {
                var template = attrs.type || "default";
                return 'app/components/directives/buscador/buscador.' + template + '.html'
            },
            controller: BuscadorController,
            controllerAs: 'buscador',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function BuscadorController($log, $state, $stateParams, Inmuebles, $scope, $rootScope) {

            var vm = this;
            vm.params = $stateParams;

            vm.inmuebles = [];
            vm.operacionChecked = operacionChecked;
            vm.situaciones = [];
            vm.situacionChecked = situacionChecked;
            vm.subsituacionChecked = subsituacionChecked;
            vm.subsituaciones = [];
            vm.subsituacionesCollection = [];
            vm.servicios = [];
            vm.servicioChecked = servicioChecked;
            vm.subtipos = [];
            vm.subtipoChecked = subtipoChecked;
            vm.clickPopover = clickPopover;
            vm.reset = reset;

            initFilters();

            vm.activePopover = "";

            vm.tipo = vm.params.tipo.slice(0, -1);
            vm.changePage = changePage;

            activate();

            function activate() {
                getJsonData();
            }

            function initFilters() {
                vm.filters = {
                    operacion: 'alquiler',
                    situacion: '',
                    subtipo: ''
                };
                vm.arrayFilters = {
                    subsituacion: [],
                    servicios: []
                };
                vm.rangeFilters = {
                    superficie_min: '',
                    superficie_max: '',
                    habitaciones_min: '',
                    banos_min: '',
                    precio_min: '',
                    precio_max: ''
                };
                vm.order = {
                    sort_by: '',
                    sort_order: ''
                };
            }
            function getStateParams() {                
                vm.filters = {
                    operacion: vm.params.operacion || '',
                    situacion: vm.params.situacion || '',
                    subtipo: vm.params.subtipo || ''
                };
                vm.arrayFilters = {
                    subsituacion: vm.params.subsituacion || [],
                    servicios: vm.params.servicios || []
                };
                vm.rangeFilters = {
                    superficie_min: vm.params.superficie_min || '',
                    superficie_max: vm.params.superficie_max || '',
                    //habitaciones_min: 0,
                    //banos_min: 0,
                    precio_min: vm.params.precio_min || '',
                    precio_max: vm.params.precio_max || ''
                };
                vm.order = {
                    sort_by: vm.params.sort_by || '',
                    sort_order: vm.params.sort_order || ''
                };
                vm.tipo = vm.params.tipo.slice(0, -1);
                vm.situacionSelected = vm.filters.situacion || "none";
                if (vm.situacionSelected !== "none") {
                    vm.situacionChecked(vm.situacionSelected, false);

                    if (vm.arrayFilters.subsituacion.length > 0) {
                        angular.forEach(vm.subsituaciones, function (value) {
                            if (vm.arrayFilters.subsituacion.indexOf(value.id) > -1) {
                                value.active = true;
                            }
                        });
                    }
                }
                if (vm.filters.subtipo !== '') {
                    angular.forEach(vm.subtipos, function (value) {
                        if (value.id === vm.filters.subtipo) {
                            value.active = true;
                        }
                    });
                }
                if (vm.arrayFilters.servicios.length > 0) {
                    angular.forEach(vm.servicios, function (value) {
                        if (vm.arrayFilters.servicios.indexOf(value.id) > -1) {
                            value.active = true;
                        }
                    });
                }
            }

            function operacionChecked() {
                changePage();
                $rootScope.$broadcast('operacionChecked', vm.filters);
                vm.situacionChecked(vm.situacionSelected, false);
            }

            function getJsonData() {

                vm.situaciones = Inmuebles.situaciones[vm.tipo];
                vm.subsituacionesCollection = Inmuebles.subsituaciones[vm.tipo];
                vm.subtipos = Inmuebles.subtipos[vm.tipo];
                vm.servicios = Inmuebles.servicios[vm.tipo];
                getStateParams();
                vm.inmuebles = Inmuebles;
                initWatchers();
                vm.inmuebles.loaded = true;
            }

            function situacionChecked(s_id, clickEvent) {
                vm.subsituaciones = [];
                if (s_id !== 'none') {
                    vm.filters.situacion = vm.situaciones[s_id].id;
                    if (clickEvent) {
                        vm.arrayFilters.subsituacion = [];
                    }
                    angular.forEach(vm.situaciones[s_id].subsituaciones, function (value, key) {
                        vm.subsituaciones.push(vm.subsituacionesCollection[key]);
                    });
                } else {
                    vm.filters.situacion = '';
                }
                if (clickEvent) {
                    changePage();
                }
            }

            function subsituacionChecked() {
                var subsituaciones_aux = [];
                angular.forEach(vm.subsituaciones, function (value) {
                    if (value.active) {
                        subsituaciones_aux.push(value.id);
                    }
                    vm.arrayFilters.subsituacion = subsituaciones_aux;
                });
                changePage();
            }

            function subtipoChecked(item) {
                if (!item.active) {
                    vm.filters.subtipo = '';
                } else {
                    vm.filters.subtipo = item.id;
                    angular.forEach(vm.subtipos, function (value) {
                        if (value.id !== item.id) {
                            value.active = false;
                        }
                    });
                }
                changePage();
            }

            function servicioChecked() {
                var servicios_aux = [];
                angular.forEach(vm.servicios, function (value) {
                    if (value.active) {
                        servicios_aux.push(value.id);
                    }
                    vm.arrayFilters.servicios = servicios_aux;
                });
                changePage();
            }

            function changePage() {
                var params = angular.extend(vm.params, vm.filters, vm.arrayFilters, vm.rangeFilters);
                $state.go('buscador', params, { notify: true });
            }

            function initWatchers() {
                $scope.$watch(function () {
                    return vm.filters;
                }, function (value) {
                    $rootScope.$broadcast('filtersChanged');
                    vm.inmuebles.setFilters(value);
                }, true);
                $scope.$watch(function () {
                    return vm.arrayFilters;
                }, function (value) {
                    vm.inmuebles.setArrayFilters(value);
                }, true);
                $scope.$watch(function () {
                    return vm.rangeFilters;
                }, function (value) {
                    vm.inmuebles.setRangeFilters(value);
                }, true);
            }

            function clickPopover(name) {
                if(vm.activePopover != name) {
                    vm.activePopover = name;
                } else {
                    vm.activePopover = '';
                }
            }

            function reset() {
                initFilters();
                changePage();
                getStateParams();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('activaProperties')
        .directive('apInmueble', apInmueble);

    /** @ngInject */
    function apInmueble() {
        var directive = {
            restrict: 'E',
            scope: {
                item: '=',
                heading: '=?',
                vertical: '=?'
            },
            templateUrl: 'app/components/directives/apInmueble/apInmueble.html',
            controller: ApInmuebleController,
            bindToController: true,
            controllerAs: 'inmueble'
        };

        return directive;

        /** @ngInject */
        function ApInmuebleController($stateParams, $state, $translate) {
            var vm = this;

            vm.lang = $stateParams.locale;
            vm.heading = vm.heading || false;
            vm.elClass = '';
            if ($state.current.name === 'home') {
                vm.elClass += 'col-xs-6 col-sm-6 col-md-4 col-lg-4 ';
            } else {
                vm.elClass += 'col-xs-6 col-sm-6 col-md-4 col-lg-2';
            }
            if (vm.vertical == true) {
                vm.elClass = 'col-md-12';
            }
            if (vm.item.destacado) {
                vm.elClass += ' destacado';
            }

            //console.log(vm.item)

            vm.imagen_principal = {};
            vm.imagen_principal.src = /*CONFIG.static +*/ vm.item.imagen;
            // if(vm.item.galeria[0].alt.length !== 0) {
            //   vm.imagen_principal.alt = vm.item.galeria[0].alt;
            // } else {
            //   vm.imagen_principal.alt = $filter('capitalize')(vm.item.title);
            // }

            vm.operacion = $translate.instant(vm.item.operacion);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('activaProperties')
        .controller('StaticController', StaticController);

    /** @ngInject */
    function StaticController(pageContent, $state, $stateParams) {
        var vm = this;
        vm.page = pageContent;
        vm.slug = $stateParams.slug;
        if (vm.page.image) {
            vm.page.image = /*CONFIG.static + "img/" +*/ vm.page.image;
        }
        if ($state.current.name == 'static') {

            vm.map = {
                center: {
                    latitude: 41.3996375,
                    longitude: 2.1496687
                },
                zoom: 13,
                options: {
                    scrollwheel: false
                }
            };
            vm.marker = {
                type: "marker",
                center: {
                    latitude: 41.3996375,
                    longitude: 2.1496687
                }
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('activaProperties')
        .controller('ListController', ListController);

    /** @ngInject */
    function ListController($filter, $stateParams, $state, $scope, $translate, CONFIG, $rootScope, Metas, Inmuebles) {
        var vm = this;
        vm.tipo = $stateParams.tipo;
        vm.stateParams = $stateParams;
        vm.orderBy = [{
                name: $translate.instant('INMUEBLE_LIST.ORDEN.RELEVANCIA'),
                sort_by: 'destacado',
                sort_order: 'DESC',
                reverse: true
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.PRECIO_M2_ASC'),
                sort_by: 'precio_m2',
                sort_order: 'ASC',
                reverse: false
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.PRECIO_M2_DESC'),
                sort_by: 'precio_m2',
                sort_order: 'DESC',
                reverse: true
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.PRECIO_ASC'),
                sort_by: 'precio',
                sort_order: 'ASC',
                reverse: false
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.PRECIO_DESC'),
                sort_by: 'precio',
                sort_order: 'DESC',
                reverse: true
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.SUPERFICIA_ASC'),
                sort_by: 'superficie',
                sort_order: 'ASC',
                reverse: false
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.SUPERFICIA_DESC'),
                sort_by: 'superficie',
                sort_order: 'DESC',
                reverse: true
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.FECHA_PUB_DESC'),
                sort_by: 'fecha',
                sort_order: 'DESC',
                reverse: true
            },
            {
                name: $translate.instant('INMUEBLE_LIST.ORDEN.FECHA_PUB_ASC'),
                sort_by: 'fecha',
                sort_order: 'ASC',
                reverse: false
            }
        ];
        vm.static_url = CONFIG.static;
        if ($stateParams.sort_by) {
            var orderBySelected = vm.orderBy.findIndex(function(x) {
                return x.sort_by === $stateParams.sort_by && x.sort_order === $stateParams.sort_order
            });
            vm.orderSelected = vm.orderBy[orderBySelected];
            //Inmuebles.setOrder(vm.orderSelected);
        } else {
            vm.orderSelected = vm.orderBy[0];
        }
        vm.orderChanged = orderChanged;

        vm.paginator = {
            items_per_page: 18,
            page: $stateParams.page || 0
        };
        vm.paginator.offset = (($stateParams.page - 1) * vm.paginator.items_per_page) || 0;

        vm.changePage = changePage;
        vm.paginationCallback = paginationCallback;

        initWatchers();

        function initWatchers() {
            $scope.$watch(function() {
                return vm.orderSelected;
            }, function(value) {
                Inmuebles.setOrder(value);
            }, true);
        }

        function orderChanged() {
            changePage();
        }

        function paginationCallback() {
            vm.changePage();
            var element = angular.element('#content');
            angular.element('html').animate({ scrollTop: element.offset().top }, "slow");
        }

        function changePage() {
            vm.paginator.offset = vm.paginator.items_per_page * (vm.paginator.page - 1);
            var params = $stateParams;
            params.page = vm.paginator.page;
            params.sort_by = vm.orderSelected.sort_by;
            params.sort_order = vm.orderSelected.reverse ? 'DESC' : 'ASC';
            $state.go('buscador', params, { notify: false });
        }

        function setTitulo(vars) {
            var tipo_str = $translate.instant(vm.tipo.toUpperCase());
            if (vars.subtipo) {
                tipo_str = Inmuebles.subtipos[vm.tipo.slice(0, -1)][vars.subtipo].titulo[$stateParams.locale];
            }
            var operacion_str = $translate.instant(vars.operacion);
            var title_args = {
                tipo: tipo_str,
                operacion: operacion_str
            };
            vm.titulo = $translate.instant('INMUEBLE_LIST.TITULO_VARIABLE', title_args);
            if (vars.situacion) {
                vm.titulo += $translate.instant('BUSCADOR.EN');
                vm.titulo += Inmuebles.situaciones[vm.tipo.slice(0, -1)][vars.situacion].titulo;
            }
            Metas.setMetas(vm.titulo);
        }

        var onFiltersChangedBroadcast = $rootScope.$on('filtersChanged', function() {
            setTitulo(Inmuebles.filters)
        });
        $scope.$on("$destroy", onFiltersChangedBroadcast);

        /*-----------MAPA--------------*/

        vm.map = {
            center: { latitude: 41.6155163, longitude: 1.6820842 },
            options: {
                icon: { url: 'https://activaproperties.com/assets/images/marker.png' }
            },
            fit: true,
            type: 'cluster',
            zoom: 8,
            events: {
                zoom_changed: function(map) {
                    vm.map.fit = false;
                    vm.map.zoom = map.getZoom();
                    if (map.getZoom() < 17) {
                        vm.map.type = 'cluster';
                    } else {
                        vm.map.type = 'spider';
                    }
                }
            },
            markersEvents: {
                click: function(marker, eventName, model) {
                    vm.map.infoWindow.model = model;
                    vm.map.infoWindow.marker = marker;
                    vm.map.infoWindow.url = $state.href('detail', { referencia: model.referencia, operacion: model.operacion, tipo: model.tipo, situacion: model.situacion, subsituacion: model.subsituacion });
                    vm.map.infoWindow.show = true;
                }
            },
            infoWindow: {
                marker: {},
                show: false,
                closeClick: function() {
                    vm.map.infoWindow.show = false;
                },
                options: {}, // define when map is ready
                title: '',
                image: '',
                url: ''
            }
        };

    }
})();
(function() {
    'use strict';

    angular
        .module('activaProperties')
        .controller('DetailController', DetailController);

    /** @ngInject */
    function DetailController($stateParams, Inmuebles, CONFIG, PreviousState, inmueble, $state, Sidebars, Metas, $filter, $translate) {
        var RANGO_SUPERFICIE_NAVE = 4000;
        var RANGO_SUPERFICIE_OFICINA = 100;
        var vm = this;
        var tipo = $stateParams.tipo;
        var referencia = $stateParams.referencia;

        vm.filterBySurface = function(tipo, inmueble_relacionado) {
            return function(item) {
                if (tipo == "nave") {
                    return item.superficie < inmueble_relacionado + RANGO_SUPERFICIE_NAVE && item.superficie > inmueble_relacionado - RANGO_SUPERFICIE_NAVE;
                } else {
                    return item.superficie < inmueble_relacionado + RANGO_SUPERFICIE_OFICINA && item.superficie > inmueble_relacionado - RANGO_SUPERFICIE_OFICINA;
                }
            }
        };

        vm.map = {
            center: {},
            zoom: 13,
            type: 'marker',
            option: {},
            isLoaded: false,
            control: {}
        };
        vm.inmueble = {};
        vm.open = false;
        vm.opts = {
            index: 0,
            bgOpacity: 0.87,
            history: false
        };
        vm.sidebars = Sidebars;

        vm.showGallery = function(i) {
            if (angular.isDefined(i)) {
                vm.opts.index = i;
            }

            vm.open = true;
        };

        vm.closeGallery = function() {
            vm.open = false;
        };

        vm.slides = [];
        vm.situaciones = Inmuebles.situaciones[tipo];
        vm.servicios = Inmuebles.servicios[tipo];
        vm.subtipos = Inmuebles.subtipos[tipo];
        vm.subsituaciones = Inmuebles.subsituaciones[tipo];
        var tipo_str = $translate.instant(inmueble.tipo);
        var operacion_str = $translate.instant(inmueble.operacion);

        var titulo = inmueble.titulo[$stateParams.locale] + ' | ' + inmueble.referencia;
        var descripcion = "";
        if (inmueble.meta_description.length > 0 && $stateParams.locale === "es") {
            descripcion = inmueble.meta_description;
        } else {
            descripcion = $translate.instant('INMUEBLE_DET.META_DESC', {
                tipo: tipo_str,
                superficie: inmueble.superficie,
                operacion: operacion_str,
                situacion: vm.situaciones[inmueble.situacion].titulo,
                subsituacion: $filter('capitalize')(vm.subsituaciones[inmueble.subsituacion].titulo)
            }) + ' | ' + inmueble.referencia;
        }

        var title_args = {
            tipo: tipo_str,
            operacion: operacion_str,
            subsituacion: $filter('capitalize')(vm.subsituaciones[inmueble.subsituacion].titulo),
            situacion: vm.situaciones[inmueble.situacion].titulo,
            superficie: inmueble.superficie
        };

        if (inmueble.tipo == 'nave') {
            title_args.direccion = inmueble.codigo_postal;
        }

        titulo = $translate.instant('INMUEBLE_DET.META_TITLE', title_args) + ' | ' + inmueble.referencia;

        inmueble.direccion = inmueble.direccion.split(', Nº')[0];

        Metas.setMetas($filter('capitalize')(titulo), descripcion, inmueble.imagen, 'product');

        var server = CONFIG.api + 'inmueble/' + $stateParams.locale + '/' + tipo + '/' + referencia + '/';
        vm.print_url = server + 'html';
        vm.pdf_url = server + 'pdf';
        vm.inmueble = inmueble;
        vm.map.isLoaded = true;
        vm.map.center = angular.copy(vm.inmueble.localizacion);
        vm.map.markerCenter = vm.inmueble.localizacion;
        if (vm.inmueble.tipo == 'nave') {
            vm.map.type = "circle";
        }
        if (PreviousState.name) {
            vm.go_back = PreviousState.url;
        } else {
            vm.go_back = $state.href('buscador', { tipo: vm.inmueble.tipo + "s", operacion: vm.inmueble.operacion });
        }

        angular.forEach(vm.inmueble.galeria, function(value) {
            var img = new Image();
            img.onload = function() {
                vm.slides.push({ src: /*CONFIG.static +*/ value.src, w: img.width, h: img.height });
            }
            img.src = /*CONFIG.static +*/ value.src;
        });
        vm.situacionLink = $state.href('buscador', { tipo: vm.inmueble.tipo + "s", operacion: vm.inmueble.operacion, situacion: vm.inmueble.situacion });
    }
})();
(function() {
    'use strict';

    angular
        .module('activaProperties')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController(Inmuebles, RESIDENCIAL, $http, $translate, CONFIG) {
        var vm = this;
        vm.paginator = {
            items_per_page: 6,
            naves: {
                offset: 0,
                page: 1
            },
            oficinas: {
                offset: 0,
                page: 1
            }
        }
        vm.isResidencial = RESIDENCIAL;
        vm.changePage = changePage;
        //vm.prevPage = prevPage;
        //vm.nextPage = nextPage;

        vm.slider = {
            slides: [],
            interval: 5000,
            noWrapSlides: false
        };

        var filters = {
            destacado: true
        };

        vm.api_url = CONFIG.api;
        vm.img_url = /*CONFIG.static +*/ 'img/';

        vm.posts = [];



        activate();

        function activate() {
            getInmuebles();
            loadSlider();
            getPosts();
        }

        function loadSlider() {
            $http.get(CONFIG.api + 'get/file/slider').success(function(slider) {
                vm.slider.slides = RESIDENCIAL ? slider.pisos : slider.naves;
            });
        }

        var titulo_key = 'HOME.TITULO_FORM.';
        if (RESIDENCIAL) {
            titulo_key += "RESIDENCIAL";
        } else {
            titulo_key += "NAVES";
        }
        vm.titulo_form = "";
        $translate(titulo_key).then(function(msg) {
            vm.titulo_form = msg;
        });

        function getInmuebles() {
            Inmuebles.setFilters(filters);
        }

        /*function prevPage(tipo) {
          vm.paginator[tipo].page--;
          changePage(tipo);
        }

        function nextPage(tipo) {
          vm.paginator[tipo].page++;
          changePage(tipo);
        }*/

        function changePage(tipo) {
            //angular.element('.inmuebles-list.'+tipo).animate({opacity: 0}, 400, function() {
            vm.paginator[tipo].offset = vm.paginator.items_per_page * (vm.paginator[tipo].page - 1);
            //});
            //angular.element('.inmuebles-list.'+tipo).animate({opacity: 1});
        }

        function getPosts() {
            $http.get('https://activaproperties.com/blog/wp-json/wp/v2/posts/?per_page=4').success(function(posts) {
                vm.posts = posts;
                for (var i = 0; i < vm.posts.length; i++) {
                    if (vm.posts[i].featured_media) {
                        $http({
                            method: 'GET',
                            url: 'https://activaproperties.com/blog/wp-json/wp/v2/media/' + vm.posts[i].featured_media,
                            postIndex: i
                        }).then(function(media) {
                            vm.posts[media.config.postIndex].image = media.data.media_details.sizes.medium.source_url;
                        });
                    }
                }
            });
        }

    }
})();
(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, Auth, Metas) {
    var vm = this;

    vm.credentials = {
      email: '',
      password: ''
    };

    vm.errors = {};

    vm.submit = submit;
    Metas.setMetas();

    function submit () {
      Auth.$signInWithEmailAndPassword(vm.credentials.email, vm.credentials.password).then(function() {
        $state.go('importar');
      }).catch(function(error) {
        vm.errors.code = error.code;
        vm.errors.message = error.message;
      });
    }
    
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('ImportarController', ImportarController);

  /** @ngInject */
  function ImportarController(CONFIG, $http, Metas) {
    var vm = this;
    var currentStep = 0;
    vm.totalInmuebles = 0;
    vm.totalUrls = 0;
    vm.status = 'waiting';
    vm.steps = [
      { action: 'importar/inmuebles/', status: 'pending', name: '1. Importar inmuebles' }, 
      { action: 'importar/textos/', status: 'pending', name: '2. Importar traducciones', offset: 0 }, 
      { action: 'exportar/json/', status: 'pending', name: '3. Crear caché' },
      { action: 'exportar/sitemap/', status: 'pending', name: '4. Crear sitemap' }
    ];
    vm.beginImport = beginImport;

    Metas.setMetas();

    function step0() {
      vm.steps[currentStep].status = 'processing';
      $http.get(CONFIG.api+vm.steps[currentStep].action)
        .then(function(response) {
          vm.totalInmuebles = response.data.inmuebles;
          currentStep++;
          step1();
        });
    }

    function step1() {
      vm.steps[currentStep - 1].status = 'completed';
      vm.steps[currentStep].status = 'processing';
      $http.get(CONFIG.api+vm.steps[currentStep].action+vm.steps[currentStep].offset+'/100')
        .then(function(response) {
          vm.steps[currentStep].offset = vm.steps[currentStep].offset + response.data.processed;
          if(response.data.processed<100){
            currentStep++;
            step2();
          } else {
            step1();
          }
        });
    }

    function step2() {
      vm.steps[currentStep - 1].status = 'completed';
      vm.steps[currentStep].status = 'processing';
      $http.get(CONFIG.api+vm.steps[currentStep].action)
        .then(function() {
          currentStep++;
          step3();
        }); 
    }

    function step3() {
      vm.steps[currentStep - 1].status = 'completed';
      vm.steps[currentStep].status = 'processing';
      $http.get(CONFIG.api+vm.steps[currentStep].action)
        .then(function(response) {
          vm.steps[currentStep].status = 'completed';
          vm.totalUrls = response.data.urls;
          vm.status = 'completed';
        }); 
    }

    function beginImport() {
      vm.status = 'importing';
      step0();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('AdminController', AdminController);

  /** @ngInject */
  function AdminController() {
  }
})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, $document, $state, $stateParams, lang, inmuebles, $window, $location, RESIDENCIAL, Auth, Sidebars, $httpParamSerializer) {
    var vm = this;
    vm.getMainClass = getMainClass;
    vm.logout = logout;
    vm.sidebars = Sidebars;
    vm.state = $state;
    vm.stateParams = $stateParams;
    $rootScope.lang = lang;
    $rootScope.getPageUrl = getPageUrl;
    vm.inmuebles = inmuebles;
    vm.user = null;
    vm.mainClass = "";
    vm.menuActive = false;
    vm.isHome = false;
    
    activate();
    
    function activate() {
      setBodyClass();
      getMainClass();
      getUser();
    }
    
    function getMainClass() {
      var body = angular.element($document[0].querySelector('body'));
      if($state.current.name=='home'){
        vm.isHome = true;
        vm.mainClass = "col-md-12 col-md-offset-0 col-lg-8 col-lg-offset-2";
        body.addClass('isHome');
      } else {
        vm.isHome = false;
        vm.mainClass = "col-sm-8 col-sm-offset-4 col-md-9 col-md-offset-3 col-lg-8 col-lg-offset-2";
        body.removeClass('isHome');
      }
    }

    function setBodyClass () {
      if(RESIDENCIAL) {
        $rootScope.bodyClass = 'residencial';
      } else {
        $rootScope.bodyClass = 'activa';
      }
    }

    function logout () {
      Auth.$signOut();
      $window.location.reload();
    }

    function getUser() {
      Auth.$waitForSignIn().then(function (firebaseUser) {
        if (firebaseUser) {
          vm.user = firebaseUser.email;
        }
      });
    }

    function getPageUrl(page) {
      var params = angular.copy($location.search());
      params.page = page;
      if(page===1) {
        delete params.page;
      }
      var url = $location.path();
      var paramsStr = $httpParamSerializer(params);
      if(paramsStr.length > 0) {
        url = url + '?' + paramsStr;
      }
      return url;
    }

    /*$rootScope.$on('$stateChangeStart', function(from, to){
      if(to.parent.name !== "admin") {
        var fadeUiView = angular.element( document.querySelector( '.fade-view' ) );
        fadeUiView.addClass('ng-leave').addClass('ng-leave-active');
      }
    });*/
    var deregistrationCallback = $rootScope.$on('$stateChangeSuccess', function(){
      getMainClass();
      $window.scrollTo(0, 0);
    });
    $rootScope.$on('$destroy', deregistrationCallback);
  }
})();

angular.module('tmh.dynamicLocalePreload', ['tmh.dynamicLocale']).config(function(tmhDynamicLocaleProvider) {tmhDynamicLocaleProvider.localeLocationPattern('{{base64Locales[locale]}}');tmhDynamicLocaleProvider.addLocalePatternValue('base64Locales', 
{"en":"data:text/javascript;base64,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","es":"data:text/javascript;base64,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","ca":"data:text/javascript;base64,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"}
);});

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {
    
  }

})();

(function() {
  'use strict';

  angular
    .module('activaProperties')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    var main = {
      url: '/{locale:(?:es|ca|en)}',
      abstract: true, 
      params: {
        locale:  { value: 'es' }
      },
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main',
      resolve:{ /* @ngInject */
        lang: function($stateParams, $translate, tmhDynamicLocale) {
          $translate.use($stateParams.locale);
          tmhDynamicLocale.set($stateParams.locale);
          return $stateParams.locale;
        }, /* @ngInject */
        inmuebles: function(Inmuebles) {
          return Inmuebles.loadInmuebles().then(function(){
            return Inmuebles;
          });
        }
      }
    };

    var home = {
      name: 'home',
      parent: main,
      url: "/",
      views: {
        'mainContent': {
          templateUrl: "app/main/home/home.html",
          controller: 'HomeController',
          controllerAs: 'home'
        }
      },
      resolve: { 
        /* @ngInject */
        metas: function(Metas) {
          Metas.setMetas();
        }
      }
    };

    var buscador = {
      name: 'buscador',
      url: "/buscador/:tipo/:operacion/?situacion&subsituacion&subtipo&servicios&precio_min&precio_max&superficie_min&superficie_max&sort_by&sort_order&page",
      parent: main,
      params: {
        tipo: {
            value: 'naves',
            squash: false
        },
        operacion: {
            value: "alquiler",
            squash: false
        },
        servicios: {
            array: true
        },
        subsituacion: {
            array: true
        },
        page: {
            value: '1',
            squash: true
        }
      },
      views: {
        'mainContent': {
          templateUrl: "app/main/inmuebles/list.html",
          controller: 'ListController',
          controllerAs: 'list'
        }
      },
      resolve: { 
        /* @ngInject */
        metas: function(Metas, $translate, $stateParams) {
          var titulo = $translate.instant("INMUEBLE_LIST.TITULO_" + $stateParams.tipo.toUpperCase() + "_" + $stateParams.operacion.toUpperCase());
          Metas.setMetas(titulo);
        }
      }
    };

    var detail = {
      name: 'detail',
      url: "/i/:referencia/:operacion/:tipo/:situacion/:subsituacion/",
      parent: main,
      views: {
        'mainContent': {
          templateUrl: "app/main/inmuebles/detail.html",
          controller: 'DetailController',
          controllerAs: 'detail'
        }
      },
      resolve: { /* @ngInject */
        PreviousState: function ($state) {
          var currentStateData = {
            name: $state.current.name,
            params: $state.params,
            url: $state.href($state.current.name, $state.params)
          };
          return currentStateData;
        },
        /* @ngInject */
        inmueble: function($stateParams, inmuebles) {
          return inmuebles.getInmueble($stateParams.referencia).then(function(inmueble){
            return inmueble;
          });
        }
      }
    };

    var static_page = {
      url: "/p/:nid/:slug/",
      parent: main,
      params: {
        nid:  { value: '0' },
        slug: { value: 'not-found' }
      },
      views: {
        'mainContent': {
          templateUrl: 'app/main/static/static.html',
          controller: 'StaticController',
          controllerAs: 'static',
          resolve: { /* @ngInject */
            pageContent: function(Page, $stateParams, Metas, $translate, $filter) {
              return Page.getPage($stateParams.nid).then(function (data) {
                var title = $filter('capitalize')(data.title) + ' | ' + $translate.instant('HOME.TITULO')
                Metas.setMetas(title, data.body, "img/" + data.image);
                return data;
             });
            }
          }
        }
      }
    };

    var admin = {
      url: "/admin",
      parent: main,
      abstract: true,
      resolve: { /* @ngInject */
        user: function ($state, Auth) {
          Auth.$waitForSignIn().then(function (firebaseUser) {
            if (firebaseUser) {
              return firebaseUser;
            } else {
              $state.go('login');
            }
          });
        }
      },
      views: {
        'mainContent': {
          templateUrl: "app/main/admin/admin.html",
          controller: 'AdminController',
          controllerAs: 'admin'
        }
      }
    };

    var login = {
      url: "/login/",
      parent: main,
      resolve: { /* @ngInject */
        user: function ($state, Auth) {
          Auth.$waitForSignIn().then(function (firebaseUser) {
            if (firebaseUser) {
              $state.go('admin');
            } else {
              return true;
            }
          });
        }
      },
      views: {
        'mainContent': {
          templateUrl: "app/main/admin/login.html",
          controller: 'LoginController',
          controllerAs: 'login'
        }
      }
    };

    var slider = {
      url: "/slider/",
      parent: admin,
      views: {
        'adminContent': {
          templateUrl: "app/main/admin/slider/slider.html",
          controller: 'SliderController',
          controllerAs: 'slider'
        },
        'sidebar': {
          templateUrl: "app/main/admin/sidebar.html"
        }
      }
    };

    var slide = {
      url: "/slide/:tipo/:id/",
      parent: admin,
      views: {
        'adminContent': {
          templateUrl: "app/main/admin/slider/slide.html",
          controller: 'SlideController',
          controllerAs: 'slide'
        },
        'sidebar': {
          templateUrl: "app/main/admin/sidebar.html"
        }
      }
    };

    var paginas = {
      url: "/paginas/",
      parent: admin,
      views: {
        'adminContent': {
          templateUrl: "app/main/admin/paginas/paginas.html",
          controller: 'PaginasController',
          controllerAs: 'paginas'
        },
        'sidebar': {
          templateUrl: "app/main/admin/sidebar.html"
        }
      }
    };

    var pagina = {
      url: "/pagina/:id/",
      parent: admin,
      views: {
        'adminContent': {
          templateUrl: "app/main/admin/paginas/pagina.html",
          controller: 'PaginaController',
          controllerAs: 'pagina'
        },
        'sidebar': {
          templateUrl: "app/main/admin/sidebar.html"
        }
      }
    };

    var importar = {
      url: "",
      parent: admin,
      views: {
        'adminContent': {
          templateUrl: "app/main/admin/importar.html",
          controller: 'ImportarController',
          controllerAs: 'importar'
        },
        'sidebar': {
          templateUrl: "app/main/admin/sidebar.html"
        }
      }
    };

    // $urlRouterProvider.otherwise(function () {
    //   window.location.replace('/404.php');
    // });
    $urlRouterProvider.otherwise('/es/');
    $stateProvider
      .state('main', main)
      .state('home', home)
      .state('buscador', buscador)
      .state('detail', detail)
      .state('static', static_page)
      .state('admin', admin)
      .state('login', login)
      .state('slider', slider)
      .state('slide', slide)
      .state('paginas', paginas)
      .state('pagina', pagina)
      .state('importar', importar)
      ;
  }

})();

(function() {
    'use strict';

    angular
        .module('activaProperties')
        .constant('CONFIG', (function() {
            var host = location.host;
            var config = {};
            if (host.indexOf("activaproperties.com") > -1) {
                config.domain_activa = 'https://activaproperties.com/';
                config.domain_residencial = 'https://residencial.activaproperties.com/';
                config.api = 'https://api.activaproperties.com/v3/';
                config.static = 'https://static.activaproperties.com/';
                config.env = 'prod';
            } else if (host.indexOf("dev.") > -1) {
                config.domain_activa = 'https://dev.activaproperties.com/';
                config.domain_residencial = 'http://dev.residencial.activaproperties.com/';
                config.api = 'https://api.activaproperties.com/v3/';
                config.static = 'http://static.activaproperties.com/';
                config.env = 'staging';
            } else {
                config.domain_activa = 'http://localhost:3000/';
                config.domain_residencial = 'http://residencial.localhost:3000/';
                config.api = 'http://127.0.0.1:8000/app_dev.php/v3/';
                config.static = 'https://static.activaproperties.com/';
                config.env = 'dev';
            }
            return config;
        })())
        .constant('RESIDENCIAL', (function() {
            var host = location.host;
            if (host.indexOf("residencial") > -1) {
                return true;
            }
            return false;
        })());

})();
(function() {
  'use strict';

  angular
    .module('activaProperties')
    .config(config);

  /** @ngInject */
  function config($translateProvider, $logProvider, $locationProvider, $httpProvider, CONFIG, $provide) {
    $logProvider.debugEnabled(CONFIG.env !== 'prod');
    $locationProvider.html5Mode(true);
    $translateProvider.preferredLanguage('es');
    $translateProvider.useLoader('translator');
    $translateProvider.useSanitizeValueStrategy(null);
    $httpProvider.defaults.cache = (CONFIG.env === 'prod');
    $provide.decorator('taOptions', ['$delegate', function(taOptions){
      taOptions.toolbar = [
        ['h3', 'h4', 'p'],
        ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo'],
        ['html', 'insertLink']
      ];
      return taOptions;
    }]);
    //$httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = 'true';
  }

})();

angular.module("activaProperties").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"{{ main.state.current.name | slugify }}\"><div class=main-content-wrapper><acme-navbar></acme-navbar><div ng-cloak><div ui-view=mainContent class=fade-view ng-animate></div></div></div></div><div class=container><div class=row><div class=col-md-12><busquedas-populares></busquedas-populares></div></div></div><footer class=footer><div class=footer-backdrop><div class=container><div class=row><div class=\"col-sm-3 logo-footer\"><div class=title translate>Activa Properties</div><div class=content><img src=/assets/images/Activalogo_Color-Light.png alt=\"Activa Properties\"><p translate>HOME.DESCRIPCION</p></div></div><div class=\"col-sm-3 contacto\"><div class=title translate>Contáctanos</div><div class=content><p class=footer-address>Carrer Balmes 243, 4º-1ª<br>08006 Barcelona<br><a class=email href=mailto:info@activaproperties.com>info@activaproperties.com</a><br></p><div class=telephones>Tel: <a href=\"tel:+34 93 517 12 12\">+34 93 517 12 12</a></div><p></p><div class=social-wrapper><ul class=\"nav navbar-nav social\"><li><a target=_blank href=https://www.facebook.com/Activa-Properties-133056493891498/ class=facebook><i class=\"fa fa-facebook\" aria-hidden=true></i></a></li><li><a target=_blank href=https://twitter.com/ActivaProp class=twitter><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a target=_blank href=https://www.linkedin.com/company/activaproperties class=linkedin><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a target=_blank href=https://www.instagram.com/activa_properties/ class=instagram><i class=\"fa fa-instagram\" aria-hidden=true></i></a></li></ul></div></div></div><div class=\"col-sm-3 conocenos\"><div class=title translate>Conócenos</div><div class=content><div class=menu-footer><a ui-sref=\"static({ nid: 775, slug: ( \'MENU.QUIENES_SOMOS\' | translate | slugify )})\" translate>MENU.QUIENES_SOMOS</a></div><div class=menu-footer><a ui-sref=\"buscador(\n                {\n                  tipo: \'naves\',\n                  operacion: null,\n                  situacion: \'\',\n                  subsituacion: [],\n                  subtipo: \'\',\n                  servicio: [],\n                  page: \'\'\n                }\n              )\" translate>MENU.BUSCADOR.NAVES_INDUSTRIALES</a></div><div class=menu-footer><a ui-sref=\"buscador(\n                {\n                  tipo: \'oficinas\',\n                  operacion: null,\n                  situacion: \'\',\n                  subsituacion: [],\n                  subtipo: \'\',\n                  servicio: [],\n                  page: \'\'\n                }\n              )\" translate>MENU.BUSCADOR.OFICINAS</a></div><div class=menu-footer><a ui-sref=\"buscador(\n                {\n                  tipo: \'locals\',\n                  operacion: null,\n                  situacion: \'\',\n                  subsituacion: [],\n                  subtipo: \'\',\n                  servicio: [],\n                  page: \'\'\n                }\n              )\" translate>MENU.BUSCADOR.LOCALES</a></div><div class=menu-footer><a href=https://activaproperties.com/blog translate target=_blank>MENU.BLOG</a></div><br><div class=menu-footer><a ui-sref=\"static({ nid: 2785, slug: ( \'MENU.POLITICA_COOKIES\' | translate | slugify )})\" translate>MENU.POLITICA_COOKIES</a></div><div class=menu-footer><a ui-sref=\"static({ nid: 2786, slug: ( \'MENU.AVISO_LEGAL\' | translate | slugify )})\" translate>MENU.AVISO_LEGAL</a></div></div></div></div><div class=\"col-sm-4 col-md-3 col-lg-2\"></div></div></div></footer><footer class=footer2><div class=\"{{ main.mainClass }}\"><div class=container-fluid><div class=pull-left><span>Activa properties 2020 | </span><span>by <a href=http://atoomstudio.com target=_blank title=\"Atoom Studio, diseño gráfico y web\">Atoom Studio</a></span> <span ng-if=!main.user>| <a ui-sref=importar translate>MENU.LOGIN</a></span> <span ng-if=main.user>| <a ui-sref=importar translate>Admin</a></span> <span ng-if=main.user>| <a href=\"\" ng-click=main.logout() translate>MENU.LOGOUT</a></span></div></div></div></footer>");
$templateCache.put("app/components/templates/carousel.html","<div ng-mouseenter=pause() ng-mouseleave=play() class=carousel ng-swipe-right=prev() ng-swipe-left=next()><div class=carousel-inner ng-transclude></div><a role=button href class=\"left carousel-control\" ng-click=prev() ng-show=\"slides.length > 1\"><span aria-hidden=true class=\"icon-prev fa fa-chevron-left\"></span> <span class=sr-only>previous</span> </a><a role=button href class=\"right carousel-control\" ng-click=next() ng-show=\"slides.length > 1\"><span aria-hidden=true class=\"icon-next fa fa-chevron-right\"></span> <span class=sr-only>next</span></a><ol class=carousel-indicators ng-show=\"slides.length > 1\"><li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=select(slide)><span class=sr-only>slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=isActive(slide)>, currently active</span></span></li></ol></div>");
$templateCache.put("app/main/admin/admin.html","<page-header title=\"\'Administración\'\"></page-header><div class=\"view-container container admin\"><div class=col-md-2><div ui-view=sidebar></div></div><div class=col-md-10><div ui-view=adminContent></div></div></div>");
$templateCache.put("app/main/admin/importar.html","<div class=row><div class=col-md-12><h1 id=page-title>Importar inmuebles</h1><p>Pulse <strong>Comenzar</strong> para importar todos los datos!</p><div ng-if=\"importar.status == \'completed\'\" class=\"alert alert-success\" role=alert>Importación correcta!</div></div></div><hr><div class=row><div class=col-md-12><ul class=list-group><li class=list-group-item ng-class=\"{ \'list-group-item-warning\': step.status == \'processing\', \'list-group-item-success\': step.status == \'completed\' }\" ng-repeat=\"step in importar.steps\">{{ step.name }} <span ng-if=\"$index==1\"><span ng-if=\"step.status !== \'pending\'\">({{step.offset}} / {{importar.totalInmuebles}})</span> </span><span ng-if=\"$index==4\"><span ng-if=\"step.status !== \'pending\'\">({{step.offset}} / {{importar.totalUrls}})</span> </span><i ng-if=\"step.status == \'processing\'\" class=\"fa fa-spinner fa-pulse fa-lg pull-right\"></i> <i ng-if=\"step.status == \'completed\'\" class=\"fa fa-check pull-right\"></i></li></ul><button ng-if=\"importar.status == \'waiting\'\" id=comenzar type=button class=\"btn btn-primary btn-lg btn-block\" ng-click=importar.beginImport()>Comenzar!</button> <button ng-if=\"importar.status == \'importing\'\" type=button class=\"btn btn-primary btn-lg btn-block disabled\">Importando...</button></div></div>");
$templateCache.put("app/main/admin/login.html","<page-header title=\"\'MENU.LOGIN\' | translate\"></page-header><div class=\"view-container container login\"><div class=\"col-md-offset-4 col-md-4\"><div class=\"alert alert-danger\" role=alert ng-if=login.errors.code><button type=button class=close ng-click=\"login.errors = null\" aria-label=Close><span aria-hidden=true>&times;</span></button> {{login.errors.message}}</div><form><div class=form-group><label for=email>Email</label><input type=email id=email placeholder=Email class=form-control ng-model=login.credentials.email required></div><div class=form-group><label for=password>Password</label><input type=password id=password placeholder=Password class=form-control ng-model=login.credentials.password required></div><div class=form-group><input type=submit class=\"btn btn-primary btn-block\" value=\"{{ \'MENU.LOGIN\' | translate }}\" ng-click=login.submit()></div></form></div></div>");
$templateCache.put("app/main/admin/sidebar.html","<div class=container-fluid><h3 class=text-primary><span class=\"fa fa-wrench\"></span> Admin</h3><hr><ul class=\"nav nav-pills nav-stacked\"><li ui-sref-active=active><a ui-sref=importar><span class=\"fa fa-cloud-download\"></span> Importar</a></li><li ui-sref-active=active><a ui-sref=paginas><span class=\"fa fa-file\"></span> Páginas</a></li><li ui-sref-active=active><a ui-sref=slider><span class=\"fa fa-image\"></span> Slider</a></li></ul></div>");
$templateCache.put("app/main/home/home.html","<div class=video-container><video autoplay muted loop id=video-home playsinline class=\"hidden-sm hidden-xs\" poster=/assets/images/home-bg-mobile.jpg><source ng-if=!home.isResidencial src=/assets/videos/home.mp4 type=video/mp4><source ng-if=home.isResidencial src=/assets/videos/home-residencial.mp4 type=video/mp4></video><div class=\"mobile-bg visible-sm visible-xs\"></div><div class=home-simple-form-row><div class=container><div class=\"home-simple-form row\"><div class=col-md-4><h1 id=page-title class=text-primary>{{:: \'BUSCADOR.TITULO\' | translate }}</h1></div><div class=col-md-8><mini-buscador></mini-buscador></div><div class=clearfix></div></div></div></div></div><div ng-if=!home.isResidencial><div class=container><div class=row><div class=col-sm-6><h3>{{:: \'HOME.NAVES_DESTACADAS\' | translate }}</h3><div class=\"inmuebles-list naves\"><ap-inmueble item=item index=$index ng-repeat=\"item in main.inmuebles.naves | limitTo:home.paginator.items_per_page:home.paginator.naves.offset\"></ap-inmueble></div><div class=clearfix></div><nav class=paginador><ul uib-pagination total-items=main.inmuebles.naves.length ng-model=home.paginator.naves.page ng-change=\"home.changePage(\'naves\')\" items-per-page=home.paginator.items_per_page max-size=5 class=\"pagination pagination-sm\" boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; rotate=false></ul></nav></div><div class=col-sm-6><h3>{{:: \'HOME.OFICINAS_DESTACADAS\' | translate }}</h3><div class=\"inmuebles-list oficinas\"><ap-inmueble item=item index=$index ng-repeat=\"item in main.inmuebles.oficinas | limitTo:home.paginator.items_per_page:home.paginator.oficinas.offset\"></ap-inmueble></div><div class=clearfix></div><nav class=paginador><ul uib-pagination total-items=main.inmuebles.oficinas.length ng-model=home.paginator.oficinas.page ng-change=\"home.changePage(\'oficinas\')\" items-per-page=home.paginator.items_per_page max-size=5 class=\"pagination pagination-sm\" boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; rotate=false></ul></nav></div></div></div></div><div ng-if=home.isResidencial><div class=container><h3>{{:: \'HOME.VIVIENDAS_DESTACADAS\' | translate }}</h3><div class=\"inmuebles-list pisos row\"><ap-inmueble item=item index=$index ng-repeat=\"item in main.inmuebles.pisos | limitTo:home.paginator.items_per_page:home.paginator.pisos.offset\"></ap-inmueble></div><div class=clearfix></div><nav class=paginador><ul uib-pagination total-items=main.inmuebles.pisos.length ng-model=home.paginator.pisos.page ng-change=\"home.changePage(\'pisos\')\" items-per-page=home.paginator.items_per_page max-size=5 class=\"pagination pagination-sm\" boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; rotate=false></ul></nav></div></div><div class=\"newsletter text-center\"><div class=container-fluid><div class=row><div class=\"col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3\"><i class=\"fa fa-envelope\" style=font-size:3em></i><p class=h2>{{ \"HOME.NEWSLETTER.TITULO\" | translate }}</p><p>{{ \"HOME.NEWSLETTER.TEXTO\" | translate }}</p><a href=https://mailchi.mp/76299f8241e9/news-activa class=\"btn btn-primary btn-block btn-lg\" target=_blank>{{ \"HOME.NEWSLETTER.BOTON\" | translate }}</a></div></div></div></div><div class=latest-posts><div class=container><h3>{{:: \'HOME.ULTIMAS_ENTRADAS\' | translate }}</h3><div class=posts><div class=\"row post\" ng-repeat=\"post in home.posts\"><div class=col-md-3><a href={{post.link}} target=_blank title={{post.title.rendered}}><img ng-src={{post.image}} class=\"img-responsive img-thumbnail\" src=\"\" alt={{post.title.rendered}}></a></div><div class=col-md-9><h4><a href={{post.link}} target=_blank title={{post.title.rendered}}>{{post.title.rendered}}</a></h4><p ng-bind-html=post.excerpt.rendered></p><a href={{post.link}} class=\"btn btn-primary\" target=_blank title=\"{{ \'HOME.VER_MAS\' | translate }}: {{post.title.rendered}}\">{{ \'HOME.VER_MAS\' | translate }}</a></div></div></div></div></div>");
$templateCache.put("app/main/static/static.html","<page-header title=static.page.title image=static.page.image></page-header><div class=\"view-container container\"><div class=row><div class=col-md-8><span ng-bind-html=static.page.body></span></div><div class=col-md-4><share></share><contact></contact><div itemscope itemtype=http://schema.org/RealEstateAgent><div class=address itemprop=address itemscope itemtype=http://schema.org/PostalAddress><div class=info><div itemprop=name>Activa Properties</div><div itemprop=streetAddress>Carrer Balmes 243, 4º-1ª</div><div itemprop=addressLocality>Barcelona</div><div itemprop=postalCode>08006</div></div><div class=tel><a href=\"tel:+34 93 517 12 12\" itemprop=telephone>Tel. +34 93 517 12 12</a></div><div class=links><div class=\"link email\"><a href=mailto:info@activaproperties.com title=info@activaproperties.com>info@activaproperties.com</a></div><div class=\"link web\"><a href=https://activaproperties.com title=https://activaproperties.com>activaproperties.com</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/inmuebles/detail.html","<page-header title=detail.inmueble.titulo[lang]|lowercase inmueble=true image=detail.inmueble.imagen_principal.src ng-click=detail.showGallery(0)></page-header><div class=\"property-detail container view-container\" itemscope itemtype=http://schema.org/Product><div class=row><div class=col-sm-8><a class=\"btn btn-go-back\" href={{detail.go_back}} title=\"{{ \'INMUEBLE_DET.VOLVER\' | translate }}\"><i class=\"fa fa-chevron-left\"></i> {{ \'INMUEBLE_DET.VOLVER\' | translate }}</a><h1 id=page-title itemprop=name>{{detail.inmueble.titulo[lang]|lowercase}}</h1><a href={{detail.situacionLink}} class=location><span class=\"fa fa-map-marker\"></span> {{detail.situaciones[detail.inmueble.situacion].titulo|lowercase}}</a> <span class=reference>Ref.: {{detail.inmueble.referencia}}</span><hr><div class=value-wrapper><div class=precio itemprop=offers itemscope itemtype=http://schema.org/Offer ng-if=\"detail.inmueble.precio!==0\"><span itemprop=price>{{detail.inmueble.precio|currency:\'\':0}}</span>€ <span ng-if=\"detail.inmueble.operacion==\'alquiler\'\">/{{ \'INMUEBLE_DET.MES\' | translate }}</span></div><div class=precio ng-if=\"detail.inmueble.precio===0\" itemprop=offers itemscope itemtype=http://schema.org/Offer><strong>{{ \'INMUEBLE_DET.PRECIO\' | translate }}:</strong> {{ \'INMUEBLE_LIST.A_CONSULTAR\' | translate }}</div><div class=separator>|</div><div class=operacion translate>{{detail.inmueble.operacion}}</div><div class=separator>|</div><div class=superficie>{{detail.inmueble.superficie|number}}m <sup>2</sup> <span ng-if=\"detail.inmueble.precio!==0\">|<!-- {{ \'INMUEBLE_DET.PRECIO_M2\' | translate }}: --> {{detail.inmueble.precio_m2|number}}€/m <sup>2</sup></span></div></div><br><br><div><dl ng-if=\"detail.inmueble.tipo == \'oficina\' || detail.inmueble.tipo == \'piso\'\"><dt>{{ \'INMUEBLE_DET.DIRECCION\' | translate }}</dt><dd>{{detail.inmueble.direccion}}, {{detail.inmueble.codigo_postal}}</dd><dd>{{detail.situaciones[detail.inmueble.situacion].titulo}}</dd><dd>{{detail.subsituaciones[detail.inmueble.subsituacion].titulo}}</dd></dl></div><div class=info itemprop=description><div btf-markdown=detail.inmueble.descripcion[lang] class=inmueble-descripcion></div></div><div class=galeria><div uib-carousel template-url=app/components/templates/carousel.html><div uib-slide ng-repeat=\"img in detail.slides track by $index\" index=$index ng-click=detail.showGallery($index)><img ng-src={{img.src}} style=margin:auto></div><div ng-photoswipe slides=detail.slides show=detail.open on-close=detail.closeGallery() options=detail.opts></div></div></div><div class=map-container><ui-gmap-google-map ng-if=detail.map.isLoaded center=detail.map.center zoom=detail.map.zoom pan=false options=detail.map.options control=detail.map.control><ui-gmap-marker ng-if=\"detail.map.type==\'marker\'\" coords=detail.map.markerCenter title=\"Activa Properties\" idkey=1></ui-gmap-marker><ui-gmap-circle ng-if=\"detail.map.type==\'circle\'\" center=detail.map.markerCenter stroke=\"{ color: \'#FF0000\', opacity: 0.8, weight: 2 }\" fill=\"{ color: \'#FF0000\', opacity: 0.35 }\" radius=1000></ui-gmap-circle></ui-gmap-google-map></div></div><div class=col-sm-4><div class=row><div class=col-md-12><share></share></div></div><div class=\"row print-pdf\"><div class=\"col-md-6 pdf-btn\"><a target=_blank href=\"{{ detail.pdf_url }}\" title=\"{{ \'INMUEBLE_DET.PDF\' | translate }}\"><i class=\"fa fa-download\"></i><!-- &nbsp;&nbsp;{{ \'INMUEBLE_DET.PDF\' | translate }} --></a></div><div class=\"col-md-6 print-btn\"><a target=_blank href=\"{{ detail.print_url }}\" title=\"{{ \'INMUEBLE_DET.IMPRIMIR\' | translate }}\"><i class=\"fa fa-print\"></i><!-- &nbsp;&nbsp;{{ \'INMUEBLE_DET.IMPRIMIR\' | translate }} --></a></div></div><div class=row><div class=col-md-12><contact title=\"\'CONTACTO.TITULO_CORTO\' | translate\" referencia=detail.inmueble.referencia></contact></div></div><div class=row><div class=col-md-12><div class=\"col-md-12 inmuebles-list related\"><h3 ng-if=\"detail.inmueble.tipo==\'nave\'\">{{ \'INMUEBLE_DET.NAVES_RELACIONADAS\' | translate }}</h3><div class=inmuebles-list><ap-inmueble vertical=true item=item heading=true index=$index ng-repeat=\"item in main.inmuebles[detail.inmueble.tipo+\'s\'] | filter: detail.filterBySurface(detail.inmueble.tipo, detail.inmueble.superficie) | limitTo : 4 track by $index\"></ap-inmueble></div><h3 ng-if=\"detail.inmueble.tipo==\'oficina\'\">{{ \'INMUEBLE_DET.OFICINAS_RELACIONADAS\' | translate }}</h3><div class=inmuebles-list><ap-inmueble vertical=true item=item heading=true index=$index data-ng-repeat=\"item in main.inmuebles[detail.inmueble.tipo+\'s\'] | filter: detail.filterBySurface(detail.inmueble.tipo, detail.inmueble.superficie) | limitTo : 4 track by $index\"></ap-inmueble></div></div></div></div></div></div></div>");
$templateCache.put("app/main/inmuebles/list.html","<page-header title=list.titulo></page-header><div class=\"view-container container\" id=content><div class=row><div class=col-md-10><buscador type=airbnb></buscador></div><div class=col-md-2><label class=\"btn btn-primary btn-block\" ng-model=showMap uib-btn-checkbox uib-btn-checkbox-true=true uib-btn-checkbox-false=false><span ng-if=!showMap><i class=\"fa fa-map\"></i> Ver Mapa</span> <span ng-if=showMap><i class=\"fa fa-th\"></i> Ver Lista</span></label></div></div><hr><!-- <div class=\"row\">\n    <div class=\"col-md-12\">\n      <busquedas-relacionadas></busquedas-relacionadas>\n    </div>\n  </div> --><div class=row><div class=col-md-12><div ng-if=main.inmuebles.loaded><div class=mapa-list ng-if=\"main.inmuebles[list.tipo].length>0 && showMap\"><ui-gmap-google-map center=list.map.center zoom=list.map.zoom events=list.map.events><ui-gmap-window show=list.map.infoWindow.show coords=list.map.infoWindow.model.localizacion options=list.map.infoWindow.options closeclick=list.map.infoWindow.closeClick()><div class=infowindow><a href=\"{{ list.map.infoWindow.url }}\"><h3>{{ list.map.infoWindow.model.titulo[lang] | limitTo:150 }}</h3></a><div class=info-col><a href=\"{{ list.map.infoWindow.url }}\"><img ng-src=\"{{::list.static_url}}{{ list.map.infoWindow.model.imagen }}\" alt=\"{{ list.map.infoWindow.model.titulo[lang] }}\"></a></div><div class=info-col><ul class=short-info><li class=price>{{list.map.infoWindow.model.precio | currency:\'€\':0 }}</li><li>REF: {{list.map.infoWindow.model.referencia}}</li><li><strong>{{list.map.infoWindow.model.operacion|capitalize}}</strong> | {{list.map.infoWindow.model.superficie | number:0 }}m<sup>2</sup></li></ul></div></div></ui-gmap-window><ui-gmap-markers events=list.map.markersEvents idkey=\"\'referencia\'\" options=list.map.options models=main.inmuebles[list.tipo] coords=\"\'localizacion\'\" type=\"\'spider\'\" fit=list.map.fit ng-if=\"list.map.type==\'spider\'\" typeoptions=\"{keepSpiderfied: true, nearbyDistance: 50}\" dorebuildall=false></ui-gmap-markers><ui-gmap-markers events=list.map.markersEvents idkey=\"\'referencia\'\" options=list.map.options models=main.inmuebles[list.tipo] coords=\"\'localizacion\'\" type=\"\'cluster\'\" fit=list.map.fit ng-if=\"list.map.type==\'cluster\'\" dorebuildall=false></ui-gmap-markers></ui-gmap-google-map></div><p ng-if=\"main.inmuebles[list.tipo].length==0 && showMap\">{{ \'INMUEBLE_LIST.NO_HAY_RESULTADOS\' | translate }}</p><div class=grid-list ng-if=!showMap><div class=\"resumen h4\"><div class=row><div class=col-md-6><div class=results-count ng-if=\"main.inmuebles[list.tipo].length>0\"><div class=h4>{{ \'INMUEBLE_LIST.MOSTRANDO\' | translate }} <span ng-if=\"list.paginator.items_per_page<=main.inmuebles[list.tipo].length\">{{list.paginator.items_per_page}}</span> <span ng-if=\"list.paginator.items_per_page>main.inmuebles[list.tipo].length\">{{main.inmuebles[list.tipo].length}}</span> {{ \'INMUEBLE_LIST.RESULTADOS_DE\' | translate }} {{main.inmuebles[list.tipo].length}}:</div></div></div><div class=col-md-6><div class=\"form-inline pull-right\"><div class=form-group><select id=sort-results class=form-control ng-if=\"main.inmuebles[list.tipo].length>0\" ng-model=list.orderSelected ng-options=\"order as order.name for order in list.orderBy\" ng-change=list.orderChanged()></select><label for=sort-results><!-- {{ \'INMUEBLE_LIST.ORDEN.TITLE\' | translate }}  --> <i class=\"fa fa-sort-amount-asc hidden-xs\"></i></label></div></div></div></div><p ng-if=\"main.inmuebles[list.tipo].length==0\">{{ \'INMUEBLE_LIST.NO_HAY_RESULTADOS\' | translate }}</p></div><div class=inmuebles-list><ap-inmueble item=item heading=true index=$index ng-repeat=\"item in main.inmuebles[list.tipo] | orderBy: list.orderSelected.sort_by: list.orderSelected.reverse | limitTo:list.paginator.items_per_page:list.paginator.offset\"></ap-inmueble></div><div class=clearfix></div><nav class=paginador ng-if=\"main.inmuebles[list.tipo].length > 0\"><ul uib-pagination class=pagination total-items=main.inmuebles[list.tipo].length ng-model=list.paginator.page ng-change=list.paginationCallback() items-per-page=list.paginator.items_per_page max-size=5 class=\"pagination pagination-sm\" boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; rotate=false template-url=app/main/inmuebles/pagination.html></ul></nav></div></div></div></div></div>");
$templateCache.put("app/main/inmuebles/pagination.html","<li ng-if=::boundaryLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=pagination-first><a href=\"\" ng-click=\"selectPage(1, $event);$event.preventDefault();$event.stopPropagation();\">{{::getText(\'first\')}}</a></li><li ng-if=::directionLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=pagination-prev><a href=\"\" ng-click=\"selectPage(page - 1, $event);$event.preventDefault();$event.stopPropagation();\">{{::getText(\'previous\')}}</a></li><li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=pagination-page><a href={{$root.getPageUrl(page.number)}} ng-click=\"selectPage(page.number, $event);$event.preventDefault();$event.stopPropagation();\">{{page.text}}</a></li><li ng-if=::directionLinks ng-class=\"{disabled: noNext()||ngDisabled}\" class=pagination-next><a href=\"\" ng-click=\"selectPage(page + 1, $event);$event.preventDefault();$event.stopPropagation();\">{{::getText(\'next\')}}</a></li><li ng-if=::boundaryLinks ng-class=\"{disabled: noNext()||ngDisabled}\" class=pagination-last><a href=\"\" ng-click=\"selectPage(totalPages, $event);$event.preventDefault();$event.stopPropagation();\">{{::getText(\'last\')}}</a></li>");
$templateCache.put("app/main/inmuebles/share.modal.html","<div class=modal-header><button type=button class=close ng-click=modal.cancelar() aria-label=Close><span aria-hidden=true>&times;</span></button><h3 class=modal-title id=modal-title>Envia esta propiedad por email</h3></div><div class=modal-body id=modal-body><div class=row><div class=\"form-group col-md-12\"><div class=\"alert alert-{{alert.type}}\" role=alert ng-repeat=\"alert in modal.contactAlerts\"><button type=button class=close ng-click=modal.closeAlert(index) aria-label=Close><span aria-hidden=true>&times;</span></button> {{alert.msg}}</div></div></div><form ng-submit=modal.enviar() ng-if=\"modal.contactAlerts.length === 0\"><div class=row><div class=\"form-group col-md-6\"><input class=form-control ng-model=modal.params.from_name type=text name=from_name placeholder=\"Tu nombre\" required></div><div class=\"form-group col-md-6\"><input class=form-control ng-model=modal.params.from_email type=text name=from_email placeholder=\"Tu email\" required></div></div><div class=row><div class=\"form-group col-md-6\"><input class=form-control ng-model=modal.params.to_name type=text name=to_name placeholder=\"El nombre de tu amigo/a\" required></div><div class=\"form-group col-md-6\"><input class=form-control ng-model=modal.params.to_email type=text name=to_email placeholder=\"El email de tu amigo/a\" required></div></div><div class=form-group><textarea class=form-control ng-model=modal.params.message name=message placeholder=\"¿Quieres añadir un mensaje?\"></textarea></div><button class=\"btn btn-primary btn-block\" type=submit ng-disabled=modal.sending>Enviar</button></form></div>");
$templateCache.put("app/components/directives/apInmueble/apInmueble.html","<div class=\"inmuebles-list-item {{inmueble.elClass}}\" itemscope itemtype=http://schema.org/Product><div class=thumbnail><a class=inmuebles-list-item-link ui-sref=\"detail({referencia: inmueble.item.referencia, operacion: inmueble.item.operacion, tipo: inmueble.item.tipo, situacion: inmueble.item.situacion, subsituacion: inmueble.item.subsituacion})\" style=\"background:url(\'{{::inmueble.imagen_principal.src}}\') scroll no-repeat 50% transparent; background-size:cover\" title={{::inmueble.item.titulo[inmueble.lang]|lowercase}}></a><div class=\"caption inmuebles-list-item-body\"><h2 class=inmuebles-list-item-title ng-if=inmueble.heading><a ui-sref=\"detail({referencia: inmueble.item.referencia, operacion: inmueble.item.operacion, tipo: inmueble.item.tipo, situacion: inmueble.item.situacion, subsituacion: inmueble.item.subsituacion})\" title={{::inmueble.item.titulo[inmueble.lang]|lowercase}} itemprop=url><span itemprop=name>{{::inmueble.item.titulo[inmueble.lang]|capitalize|limitTo:150}}</span></a></h2><span class=inmuebles-list-item-title ng-if=!inmueble.heading><a ui-sref=\"detail({referencia: inmueble.item.referencia, operacion: inmueble.item.operacion, tipo: inmueble.item.tipo, situacion: inmueble.item.situacion, subsituacion: inmueble.item.subsituacion})\" title={{::inmueble.item.titulo[inmueble.lang]|lowercase}} itemprop=url><span itemprop=name>{{::inmueble.item.titulo[inmueble.lang]|capitalize|limitTo:150}}</span></a></span><div class=short-info><span itemprop=offers itemscope itemtype=http://schema.org/Offer><span ng-if=\"inmueble.item.precio!==0\" class=price itemprop=price>{{::inmueble.item.precio | currency:\'€\':0 }}</span> <span ng-if=\"inmueble.item.precio===0\" class=\"price consultar\" itemprop=price>{{ \'INMUEBLE_LIST.A_CONSULTAR\' | translate }}</span> </span><span>REF: {{::inmueble.item.referencia}}</span> <span><strong>{{::inmueble.operacion|capitalize}}</strong><br>{{::inmueble.item.superficie | number:0 }}m<sup>2</sup></span></div><div class=\"btn-group btn-group-justified\" role=group><a ui-sref=\"detail({referencia: inmueble.item.referencia, operacion: inmueble.item.operacion, tipo: inmueble.item.tipo, situacion: inmueble.item.situacion, subsituacion: inmueble.item.subsituacion})\" class=btn role=button title=\"{{:: \'INMUEBLE_LIST.VER_MAS\' | translate }}\">{{:: \'INMUEBLE_LIST.VER_MAS\' | translate }}</a></div></div></div></div>");
$templateCache.put("app/components/directives/busquedas-populares/busquedas-populares.html","<div class=busquedas-populares><div class=h4>{{ \'MAIN.BUSQUEDAS_POPULARES\' | translate}}</div><span ng-if=!pop.isResidencial><span ng-repeat=\"situacion in pop.navesSeleccionadas\"><span ng-repeat=\"operacion in pop.operaciones\"><a class=badge ui-sref-opts=\"{reload: true}\" ui-sref=\"buscador({tipo: \'naves\', operacion: operacion, situacion: situacion, subsituacion: [], subtipo: subtipo.id, servicio: [],page: \'\'})\"><span translate=\"MAIN.NAVES_POPULARES_{{ operacion }}\" translate-values=\"{ situacion: pop.situacionesNaves[situacion].titulo }\"></span> </a></span></span><span ng-repeat=\"situacion in pop.oficinasSeleccionadas\"><a class=badge ui-sref-opts=\"{reload: true}\" ui-sref=\"buscador({tipo: \'oficinas\', operacion: \'alquiler\', situacion: situacion[0], subsituacion: [ situacion[1] ], subtipo: subtipo.id, servicio: [],page: \'\'})\"><span translate=MAIN.OFICINAS_POPULARES translate-values=\"{ situacion: pop.situacionesOficinas[situacion[0]].titulo, subsituacion: pop.subsituacionesOficinas[situacion[1]].titulo }\"></span> </a></span></span><span ng-if=pop.isResidencial><span ng-repeat=\"situacion in pop.pisosSeleccionados\"><span ng-repeat=\"subtipo in pop.subtiposPisos\"><span ng-repeat=\"operacion in pop.operaciones\"><a class=badge ui-sref-opts=\"{reload: true}\" ui-sref=\"buscador({tipo: \'pisos\', operacion: operacion, situacion: situacion, subsituacion: [], subtipo: subtipo.id, servicio: [],page: \'\'})\">{{ subtipo.titulo[pop.locale] }} <span translate=\"MAIN.PISOS_POPULARES_{{ operacion }}\" translate-values=\"{ situacion: pop.situacionesPisos[situacion].titulo }\"></span></a></span></span></span></span></div>");
$templateCache.put("app/components/directives/busquedas-relacionadas/busquedas-relacionadas.html","<div class=busquedas-relacionadas ng-if=\"!(rel.links | isEmpty)\"><div class=h4>Búsquedas relacionadas</div><ul><li ng-repeat=\"link in rel.links\"><a ui-sref=\"buscador({tipo: link.tipo + \'s\', operacion: link.operacion, situacion: link.situacion.id, subsituacion: [], subtipo: link.subtipo.id, servicios: link.servicios.id,page: \'\'})\">{{ link.subtipo.titulo[rel.lang] || link.tipo | capitalize }} en {{ link.operacion }} en {{ link.situacion.titulo }} <span ng-if=link.servicios.id>con {{ link.servicios.titulo[rel.lang] }}</span></a></li></ul></div>");
$templateCache.put("app/components/directives/miniBuscador/miniBuscador.form.html","<div class=\"buscador-simple-home row\"><form ng-submit=mini.srv.fireSearch()><div class=\"form-group text-center\" ng-class=mini.formClasses ng-if=!mini.srv.isResidencial><select id=selectTipo ng-model=mini.srv.params.tipo class=\"form-control text-white btn-secondary\" ng-options=\"option.value as option.title for option in mini.srv.tipos\"></select></div><div class=\"form-group text-center\" ng-class=mini.formClasses><select id=selectOperacion ng-model=mini.srv.params.operacion class=\"form-control text-white btn-secondary\" ng-options=\"option.value as option.title for option in mini.srv.operaciones\"></select></div><!-- <div class=\"form-group text-center\" ng-class=\"mini.formClasses\">\n      <select id=\"selectSituaciones1\" ng-model=\"mini.srv.params.situacion\" class=\"form-control text-white btn-secondary\" ng-options=\"option.id as option.titulo for option in mini.srv.situaciones[mini.srv.params.tipo.slice(0, -1)]\">\n        <option value=\"\">{{:: \'BUSCADOR.TODAS\' | translate }}</option>\n      </select>\n    </div> --><div class=\"form-group text-center col-sm-12 col-md-3 submit\"><button class=\"btn btn-primary btn-block\" type=submit><i class=\"fa fa-search\"></i> {{:: \'BUSCADOR.BUSCAR\' | translate }}</button></div></form></div>");
$templateCache.put("app/components/directives/miniBuscador/miniBuscador.modal.html","<div class=modal-header><button type=button class=close ng-click=mini.cancelar() aria-label=Close><span aria-hidden=true>&times;</span></button><h3 class=modal-title>{{ mini.title }}</h3></div><div class=modal-body><form ng-submit=mini.srv.fireSearch()><div class=form-group ng-if=!mini.srv.isResidencial><label class=text-primary for=selectTipo>{{:: \'BUSCADOR.TIPO_INMUEBLE\' | translate }}</label><select id=selectTipo ng-model=mini.srv.params.tipo class=\"form-control text-white btn-primary\" ng-options=\"option.value as option.title for option in mini.srv.tipos\"></select></div><div class=form-group><label class=text-primary for=selectOperacion>{{:: \'BUSCADOR.REGIMEN\' | translate }}</label><select id=selectOperacion ng-model=mini.srv.params.operacion class=\"form-control text-white btn-primary\" ng-options=\"option.value as option.title for option in mini.srv.operaciones\"></select></div><!-- <div class=\"form-group\">\n      <label ng-if=\"mini.srv.params.tipo==\'naves\'\" class=\"text-primary\">{{:: \'BUSCADOR.ZONA\' | translate }}</label>\n      <label ng-if=\"mini.srv.params.tipo==\'oficinas\' || mini.srv.params.tipo==\'pisos\'\" class=\"text-primary\">{{:: \'BUSCADOR.POBLACION\' | translate }}</label>\n      <select id=\"selectSituaciones1\" ng-model=\"mini.srv.params.situacion\" class=\"form-control text-white btn-primary\" ng-options=\"option.id as option.titulo for option in mini.srv.situaciones[mini.srv.params.tipo.slice(0, -1)]\">\n        <option value=\"\">{{:: \'BUSCADOR.TODAS\' | translate }}</option>\n      </select>\n    </div> --> <input class=\"btn btn-primary btn-block\" type=submit value=\"{{:: \'BUSCADOR.BUSCAR\' | translate }}\"></form></div>");
$templateCache.put("app/components/directives/miniBuscador/miniBuscador.nav.html","<button type=button class=\"btn btn-primary navbar-btn\" ng-click=mini.openModal()><span class=\"fa fa-search\" aria-hidden=true></span></button>");
$templateCache.put("app/components/directives/contact/contact.default.html","<div class=contact-default ng-click=contact.openModal()><div class=row><div class=\"col-xs-3 col-md-3 text-right icon\"><span class=\"fa fa-envelope\"></span></div><div class=\"col-xs-9 col-md-9\">{{ contact.title }}<br><strong>{{ \'CONTACTO.CONTACTANOS\' | translate }}</strong></div></div></div>");
$templateCache.put("app/components/directives/contact/contact.modal.html","<div class=modal-header><button type=button class=close ng-click=modal.cancelar() aria-label=Close><span aria-hidden=true>&times;</span></button><h3 class=modal-title>{{ modal.title }}</h3></div><div class=modal-body><div class=row><div class=\"form-group col-md-12\"><div class=\"alert alert-{{alert.type}}\" role=alert ng-repeat=\"alert in modal.contactAlerts\"><button type=button class=close ng-click=modal.closeAlert(index) aria-label=Close><span aria-hidden=true>&times;</span></button> {{alert.msg}}</div></div></div><form ng-submit=modal.submitForm() ng-if=\"modal.contactAlerts.length === 0\"><div class=form-group><input type=text class=form-control ng-model=modal.contact.nom placeholder=\"{{ \'CONTACTO.NOMBRE\' | translate }}\" required></div><div class=form-group><input type=text class=form-control ng-model=modal.contact.telefon placeholder=\"{{ \'CONTACTO.TELEFONO\' | translate }}\" required></div><div class=form-group><input type=email class=form-control name=email ng-model=modal.contact.email placeholder=\"{{ \'CONTACTO.EMAIL\' | translate }}\" required></div><div class=form-group ng-if=modal.contact.ref><input type=referencia class=\"form-control text-primary\" ng-model=modal.contact.ref disabled></div><div class=form-group><textarea class=form-control ng-model=modal.contact.missatge rows=6 placeholder=\"{{ \'CONTACTO.MENSAJE\' | translate }}...\" required></textarea></div><div class=\"form-group terminos\"><small translate=CONTACTO.TERMINOS_Y_CONDICIONES translate-values=\"{url: contact.terms_link}\"></small></div><button type=submit class=\"btn btn-primary btn-block\">{{ \'CONTACTO.ENVIAR\' | translate }}</button><div class=\"form-group terminos\"><input type=checkbox name=terms ng-model=modal.contact.agreement> <small translate=CONTACTO.ACEPTO_NEWS translate-values=\"{url: contact.terms_link}\"></small></div></form></div>");
$templateCache.put("app/components/directives/contact/contact.nav.html","<button type=button class=\"btn btn-primary navbar-btn\" ng-click=contact.openModal()><span class=\"fa fa-envelope\" aria-hidden=true></span></button>");
$templateCache.put("app/components/directives/navbar/navbar.html","<div class=\"navbar-fixed-top navbar-wrapper collapsed-header navbar-default\" ng-class=\"{ active: nav.menuActive }\" id=hidden-menu><div class=container><div class=row><div class=\"col-xs-6 col-md-4\"><a class=navbar-brand ui-sref=home>Activa Properties</a></div><div class=\"col-xs-6 col-md-8\"><div class=row><div class=col-md-12><nav class=\"navbar pull-right\" ng-cloak><ul class=\"nav navbar-nav telephone hidden-xs\"><li><a href=\"tel:+34 93 517 12 12\">+34 93 517 12 12</a></li></ul><ul class=\"nav navbar-nav\"><!-- <li class=\"nav-item\">\n                  <button type=\"button\" class=\"btn btn-primary navbar-btn\">\n                    <span class=\"fa fa-search\" aria-hidden=\"true\"></span>\n                    Buscar\n                  </button>\n                </li> --><li class=\"nav-item margin-right\"><mini-buscador type=nav></mini-buscador></li><li class=nav-item><contact type=nav></contact></li><li class=nav-item><button type=button class=\"btn btn-link navbar-btn\" ng-click=nav.toggleCollapsed() id=toggle-menu><span ng-class=\"{ \'fa-bars\': nav.navCollapsed, \'fa-times\': !nav.navCollapsed}\" class=fa aria-hidden=true></span></button></li></ul></nav></div></div></div></div><div class=row><div class=col-md-12><div class=collapse uib-collapse=nav.navCollapsed><!-- ACTIVAPROPERTIES --><div ng-if=!nav.residencial><ul class=\"nav text-center\"><li ui-sref-active=active><a class=uncollapsed-menu-item ui-sref=\"static({ nid: 775, slug: ( \'MENU.QUIENES_SOMOS\' | translate | slugify )})\" translate>MENU.QUIENES_SOMOS</a></li><li><a class=uncollapsed-menu-item href translate ng-init=\"nav.serviciosCollapsed = true\" ng-click=\"nav.serviciosCollapsed = !nav.serviciosCollapsed\">MENU.SERVICIOS <span class=caret></span></a><ul class=\"nav dropdown\" uib-collapse=nav.serviciosCollapsed><li ui-sref-active=active ng-repeat=\"servicio in nav.servicios\"><a class=uncollapsed-menu-item ui-sref=\"static({nid: servicio.nid, slug: (servicio.title[nav.locale]|slugify)})\">{{servicio.title[nav.locale]}}</a></li></ul></li><!-- <li ui-sref-active=\"active\"><a ui-sref=\"mapa\" translate>MENU.MAPA</a></li> --><li ui-sref-active=active><a ui-sref=\"buscador(\n                                      {\n                                        tipo: \'naves\',\n                                        operacion: null,\n                                        situacion: \'\',\n                                        subsituacion: [],\n                                        subtipo: \'\',\n                                        servicio: [],\n                                        page: \'\'\n                                      }\n                                    )\" translate>MENU.BUSCADOR.NAVES_INDUSTRIALES</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                      {\n                                        tipo: \'oficinas\',\n                                        operacion: null,\n                                        situacion: \'\',\n                                        subsituacion: [],\n                                        subtipo: \'\',\n                                        servicio: [],\n                                        page: \'\'\n                                      }\n                                    )\" translate>MENU.BUSCADOR.OFICINAS</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                    {\n                                      tipo: \'locals\',\n                                      operacion: \'venta\',\n                                      situacion: \'\',\n                                      subsituacion: [],\n                                      subtipo: \'\',\n                                      servicio: [],\n                                      page: \'\'\n                                    }\n                                  )\" translate>MENU.BUSCADOR.LOCALES</a></li><li><a href=https://activaproperties.com/blog translate target=_blank>MENU.BLOG</a></li><li class=activa-residencial ui-sref-active=active><a href={{nav.changePortalUrl}}>Residencial</a></li></ul></div><!-- RESIDENCIAL --><div ng-if=nav.residencial><ul class=\"nav text-center\"><li ui-sref-active=active><a ui-sref=\"static({ nid: 2784, slug: ( \'MENU.VENDER_ALQUILAR\' | translate | slugify ) })\" translate>MENU.VENDER_ALQUILAR</a></li><li ui-sref-active=active><a ui-sref=\"static({ nid: 2783, slug: ( \'MENU.AGENCIA\' | translate | slugify ) })\" translate>MENU.AGENCIA</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                      {\n                                        tipo: \'pisos\',\n                                        operacion: null,\n                                        situacion: \'\',\n                                        subsituacion: [],\n                                        subtipo: \'\',\n                                        servicio: [],\n                                        page: \'\'\n                                      }\n                                    )\" translate>MENU.BUSCADOR.TITULO</a></li><li><a href=https://activaproperties.com/blog translate target=_blank>MENU.BLOG</a></li><li class=activa-residencial ui-sref-active=active><a href={{nav.changePortalUrl}}>Activa Properties</a></li></ul></div></div></div></div></div></div><div class=\"navbar-static-top navbar-wrapper full-header hidden-xs\"><div class=container><div class=row><div class=col-md-4><!-- <a class=\"navbar-brand\" ui-sref=\"home\" ng-if=\"!nav.residencial\">Activa Properties</a>\n        <a class=\"navbar-brand\" ui-sref=\"home\" ng-if=\"nav.residencial\">Residencial</a> --> <a class=navbar-brand ui-sref=home>Activa Properties</a></div><div class=col-md-8><div class=row><div class=col-md-12><nav class=\"navbar pull-right header-info\" ng-cloak><ul class=\"nav navbar-nav language-list\"><li><a title=català href=# ng-click=\"nav.switchLang(\'ca\')\">CA</a></li><li><a title=español href=# ng-click=\"nav.switchLang(\'es\')\">ES</a></li><li><a title=english href=# ng-click=\"nav.switchLang(\'en\')\">EN</a></li></ul><ul class=\"nav navbar-nav telephone\"><li><a href=\"tel:+34 93 517 12 12\"><i class=\"fa fa-phone\"></i> +34 93 517 12 12</a></li></ul><ul class=\"nav navbar-nav social\"><li><a target=_blank href=https://www.facebook.com/Activa-Properties-133056493891498/ class=facebook>Facebook</a></li><li><a target=_blank href=https://twitter.com/ActivaProp class=twitter>Twitter</a></li><li><a target=_blank href=https://www.linkedin.com/company/activaproperties class=linkedin>Linkedin</a></li><li><a target=_blank href=https://www.instagram.com/activa_properties/ class=instagram>Instagram</a></li></ul></nav></div><div class=col-md-12><nav class=\"navbar main-navbar pull-right\" role=navigation ng-cloak><div ng-if=!nav.residencial><ul class=\"nav navbar-nav\"><li ui-sref-active=active><a ui-sref=\"static({ nid: 775, slug: ( \'MENU.QUIENES_SOMOS\' | translate | slugify )})\" translate>MENU.QUIENES_SOMOS</a></li><li class=dropdown uib-dropdown on-toggle=toggled(open)><a href uib-dropdown-toggle translate>MENU.SERVICIOS <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu><li ui-sref-active=active ng-repeat=\"servicio in nav.servicios\"><a ui-sref=\"static({nid: servicio.nid, slug: (servicio.title[nav.locale]|slugify)})\">{{servicio.title[nav.locale]}}</a></li></ul></li><!-- <li ui-sref-active=\"active\"><a ui-sref=\"mapa\" translate>MENU.MAPA</a></li> --><li ui-sref-active=active><a ui-sref=\"buscador(\n                                        {\n                                          tipo: \'naves\',\n                                          operacion: null,\n                                          situacion: \'\',\n                                          subsituacion: [],\n                                          subtipo: \'\',\n                                          servicio: [],\n                                          page: \'\'\n                                        }\n                                      )\" translate>MENU.BUSCADOR.NAVES_INDUSTRIALES</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                        {\n                                          tipo: \'oficinas\',\n                                          operacion: null,\n                                          situacion: \'\',\n                                          subsituacion: [],\n                                          subtipo: \'\',\n                                          servicio: [],\n                                          page: \'\'\n                                        }\n                                      )\" translate>MENU.BUSCADOR.OFICINAS</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                        {\n                                          tipo: \'locals\',\n                                          operacion: \'venta\',\n                                          situacion: \'\',\n                                          subsituacion: [],\n                                          subtipo: \'\',\n                                          servicio: [],\n                                          page: \'\'\n                                        }\n                                      )\" translate>MENU.BUSCADOR.LOCALES</a></li><li><a href=https://activaproperties.com/blog translate target=_blank>MENU.BLOG</a></li><li class=activa-residencial ui-sref-active=active><a href={{nav.changePortalUrl}}>Residencial</a></li></ul></div><!-- RESIDENCIAL --><div ng-if=nav.residencial><ul class=\"nav navbar-nav\"><li ui-sref-active=active><a ui-sref=\"static({ nid: 2784, slug: ( \'MENU.VENDER_ALQUILAR\' | translate | slugify ) })\" translate>MENU.VENDER_ALQUILAR</a></li><li ui-sref-active=active><a ui-sref=\"static({ nid: 2783, slug: ( \'MENU.AGENCIA\' | translate | slugify ) })\" translate>MENU.AGENCIA</a></li><li ui-sref-active=active><a ui-sref=\"buscador(\n                                        {\n                                          tipo: \'pisos\',\n                                          operacion: null,\n                                          situacion: \'\',\n                                          subsituacion: [],\n                                          subtipo: \'\',\n                                          servicio: [],\n                                          page: \'\'\n                                        }\n                                      )\" translate>MENU.BUSCADOR.TITULO</a></li><li><a href=https://activaproperties.com/blog translate target=_blank>MENU.BLOG</a></li><li class=activa-residencial ui-sref-active=active><a href={{nav.changePortalUrl}}>Activa Properties</a></li></ul></div></nav></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/pageHeader/pageHeader.html","<style ng-if=\"image && !inmueble\">.main-header {\n        background-image: url(\'{{image}}\');\n    }</style><style ng-if=\"image && inmueble\">.main-header .inmueble-blur-bg,\n    .main-header .inmueble-hd-bg {\n        background-image: url(\'{{image}}\');\n    }</style><div class=main-header ng-class=\"{ \'header-inmueble\': inmueble, \'header-default\': !inmueble }\"><div ng-if=inmueble><div class=inmueble-blur-bg></div><div class=inmueble-hd-bg><i class=\"fa fa-search\"></i></div></div><div class=mask></div><div class=divider></div><div class=container ng-if=!inmueble><div class=col-md-12><h1 class=page-title>{{title | lowercase}}</h1></div></div></div>");
$templateCache.put("app/components/directives/share/share.html","<div class=sharrre><div class=row><div class=col-lg-4><span class=title>Compártelo</span></div><div class=col-lg-8><a ng-click=\"share.share(\'facebook\')\" href=# class=facebook><i class=\"fa fa-facebook\"></i> </a><a ng-click=\"share.share(\'twitter\')\" href=# class=twitter><i class=\"fa fa-twitter\"></i> </a><a ng-click=\"share.share(\'linkedin\')\" href=# class=linkedin><i class=\"fa fa-linkedin\"></i> </a><a ng-click=share.share_email() href=# class=email><i class=\"fa fa-envelope\"></i></a></div></div></div>");
$templateCache.put("app/components/directives/buscador/buscador.airbnb.html","<div class=filter-btns><button data-toggle=popover popover-trigger=\"\'outsideClick\'\" class=\"btn btn-primary popover1\" uib-popover-template=\"\'regimen.html\'\" ng-click=\"buscador.clickPopover(\'regimen\')\" popover-placement=bottom>{{ buscador.filters.operacion }} <i class=caret></i></button> <button class=\"btn popover1\" popover-trigger=\"\'outsideClick\'\" ng-class=\"{ \'btn-primary\': buscador.situacionSelected !== \'none\', \'btn-secondary\': buscador.situacionSelected === \'none\' }\" uib-popover-template=\"\'localizacion.html\'\" ng-click=\"buscador.clickPopover(\'localizacion\')\" popover-placement=bottom><span ng-if=\"!buscador.situaciones[buscador.filters.situacion].titulo && buscador.tipo==\'nave\'\">{{ \'BUSCADOR.ZONA\' | translate }}</span> <span ng-if=\"!buscador.situaciones[buscador.filters.situacion].titulo && (buscador.tipo==\'oficina\' || buscador.tipo==\'piso\' || buscador.tipo==\'local\')\">{{ \'BUSCADOR.POBLACION\' | translate }}</span> <span ng-if=buscador.situaciones[buscador.filters.situacion].titulo>{{ buscador.situaciones[buscador.filters.situacion].titulo || \'BUSCADOR.POBLACION\' | translate }} </span><i class=caret></i></button> <button popover-trigger=\"\'outsideClick\'\" class=\"btn popover1\" ng-class=\"{ \'btn-primary\': buscador.filters.subtipo, \'btn-secondary\': !buscador.filters.subtipo }\" uib-popover-template=\"\'tipo.html\'\" ng-click=\"buscador.clickPopover(\'tipo\')\" popover-placement=bottom>{{ buscador.subtipos[buscador.filters.subtipo].titulo[lang] || \'BUSCADOR.TIPO_INMUEBLE\' | translate }} <i class=caret></i></button> <button popover-trigger=\"\'outsideClick\'\" class=\"btn popover1\" ng-class=\"{ \'btn-primary\': buscador.rangeFilters.superficie_min || buscador.rangeFilters.superficie_max, \'btn-secondary\': !buscador.rangeFilters.superficie_min && !buscador.rangeFilters.superficie_max }\" uib-popover-template=\"\'superficie.html\'\" ng-click=\"buscador.clickPopover(\'superficie\')\" popover-placement=bottom><span ng-if=\"!buscador.rangeFilters.superficie_min && !buscador.rangeFilters.superficie_max\">{{ \'BUSCADOR.SUPERFICIE\' | translate }} </span><span ng-if=buscador.rangeFilters.superficie_min>{{ buscador.rangeFilters.superficie_min }}m<sup>2</sup> </span><span ng-if=\"buscador.rangeFilters.superficie_min && buscador.rangeFilters.superficie_max\">- </span><span ng-if=buscador.rangeFilters.superficie_max>{{ buscador.rangeFilters.superficie_max }}m<sup>2</sup> </span><i class=caret></i></button> <button popover-trigger=\"\'outsideClick\'\" class=\"btn popover1\" ng-class=\"{ \'btn-primary\': buscador.rangeFilters.precio_min || buscador.rangeFilters.precio_max, \'btn-secondary\': !buscador.rangeFilters.precio_min && !buscador.rangeFilters.precio_max }\" uib-popover-template=\"\'precio.html\'\" ng-click=\"buscador.clickPopover(\'precio\')\" popover-placement=bottom><span ng-if=\"!buscador.rangeFilters.precio_min && !buscador.rangeFilters.precio_max\">{{ \'BUSCADOR.PRECIO\' | translate }} </span><span ng-if=buscador.rangeFilters.precio_min>{{ buscador.rangeFilters.precio_min }}€ </span><span ng-if=\"buscador.rangeFilters.precio_min && buscador.rangeFilters.precio_max\">- </span><span ng-if=buscador.rangeFilters.precio_max>{{ buscador.rangeFilters.precio_max }}€ </span><i class=caret></i></button> <button popover-trigger=\"\'outsideClick\'\" class=\"btn popover1\" ng-class=\"{ \'btn-primary\': buscador.arrayFilters.servicios.length, \'btn-secondary\': !buscador.arrayFilters.servicios.length }\" uib-popover-template=\"\'caracteristicas.html\'\" ng-click=\"buscador.clickPopover(\'caracteristicas\')\" popover-placement=bottom ng-if=\"buscador.tipo !== \'piso\'\">{{ \'BUSCADOR.SERVICIOS\' | translate }} <i class=caret></i></button><!-- <a class=\"btn btn-warning\" href=\"/{{lang}}/buscador/{{buscador.tipo}}s/alquiler/\"ng-click=\"buscador.reset()\"> --> <a class=\"btn btn-warning\" ng-click=buscador.reset()>{{ \'BUSCADOR.RESET\' | translate }}</a></div><script type=text/ng-template id=regimen.html><div class=\"btn-group btn-group-justified\" role=\"group\">\n        <label class=\"btn btn-primary\" ng-model=\"buscador.filters.operacion\" uib-btn-radio=\"\'alquiler\'\"\n            ng-click=\"buscador.operacionChecked()\">{{ \'BUSCADOR.ALQUILER\' | translate }}</label>\n        <label class=\"btn btn-primary\" ng-model=\"buscador.filters.operacion\" uib-btn-radio=\"\'venta\'\"\n            ng-click=\"buscador.operacionChecked()\">{{ \'BUSCADOR.VENTA\' | translate }}</label>\n    </div></script><script type=text/ng-template id=localizacion.html><div class=\"form-group text-center form-situaciones1\">\n        <select ng-model=\"buscador.situacionSelected\" class=\"form-control text-white btn-primary\"\n            ng-change=\"buscador.situacionChecked(buscador.situacionSelected, true)\">\n            <option value=\"none\" selected>- {{\'BUSCADOR.TODAS\'|translate}} -</option>\n            <option ng-if=\"option.titulo!=\'\'\" ng-repeat=\"(key, option) in buscador.situaciones\" value=\"{{key}}\">{{option.titulo}}</option>\n        </select>\n    </div>\n    <div class=\"form-group text-center\" ng-if=\"buscador.filters.situacion!=\'\'\">\n        <label ng-if=\"buscador.tipo==\'nave\'\" class=\"text-primary\">{{ \'BUSCADOR.POBLACION\' | translate }}</label>\n        <label ng-if=\"buscador.tipo==\'oficina\' || buscador.tipo==\'piso\'\" class=\"text-primary\">{{\n            \'BUSCADOR.AREA\' | translate }}</label>\n        <div class=\"btn-group-vertical btn-block\" role=\"group\">\n            <label class=\"btn btn-xs btn-primary\" ng-repeat=\"sit in buscador.subsituaciones\" ng-model=\"sit.active\"\n                uib-btn-checkbox uib-btn-checkbox-true=\"\'{{sit.id}}\'\" uib-btn-checkbox-false=\"\'\'\" ng-change=\"buscador.subsituacionChecked()\">{{sit.titulo}}</label>\n        </div>\n    </div></script><script type=text/ng-template id=tipo.html><div class=\"btn-group-vertical btn-block\" role=\"group\">\n        <label ng-repeat=\"tipo in buscador.subtipos\" class=\"btn btn-primary\" ng-model=\"tipo.active\"\n            uib-btn-checkbox uib-btn-checkbox-true=\"true\" uib-btn-checkbox-false=\"false\" ng-change=\"buscador.subtipoChecked(tipo)\">{{tipo.titulo[lang]}}</label>\n    </div></script><script type=text/ng-template id=superficie.html><div class=\"form-group text-center\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'BUSCADOR.DE\' | translate }}\" ng-model=\"buscador.rangeFilters.superficie_min\"\n                ng-model-options=\"{debounce: 1000}\" ng-change=\"buscador.changePage()\">\n            <span class=\"input-group-addon text-primary\">m<sup>2</sup></span>\n        </div>\n    </div>\n    <div class=\"form-group text-center\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'BUSCADOR.HASTA\' | translate }}\"\n                ng-model=\"buscador.rangeFilters.superficie_max\" ng-model-options=\"{debounce: 1000}\"\n                ng-change=\"buscador.changePage()\">\n            <span class=\"input-group-addon text-primary\">m<sup>2</sup></span>\n        </div>\n    </div></script><script type=text/ng-template id=precio.html><div class=\"form-group text-center\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'BUSCADOR.DE\' | translate }}\" ng-model=\"buscador.rangeFilters.precio_min\"\n                ng-model-options=\"{debounce: 1000}\" ng-change=\"buscador.changePage()\">\n            <span class=\"input-group-addon text-primary\">€</span>\n        </div>\n    </div>\n    <div class=\"form-group text-center\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'BUSCADOR.HASTA\' | translate }}\"\n                ng-model=\"buscador.rangeFilters.precio_max\" ng-model-options=\"{debounce: 1000}\" ng-change=\"buscador.changePage()\">\n            <span class=\"input-group-addon text-primary\">€</span>\n        </div>\n    </div></script><script type=text/ng-template id=caracteristicas.html><div class=\"form-group text-center\">\n        <div class=\"btn-group-vertical btn-block\" role=\"group\">\n            <label class=\"btn btn-primary\" ng-repeat=\"servicio in buscador.servicios\" ng-model=\"servicio.active\"\n                uib-btn-checkbox uib-btn-checkbox-true=\"true\" uib-btn-checkbox-false=\"false\" ng-change=\"buscador.servicioChecked()\">{{servicio.titulo[lang]}}</label>\n        </div>\n    </div></script>");
$templateCache.put("app/components/directives/buscador/buscador.default.html","<div class=search-sidebar><!-- <h3 class=\"text-primary text-center\"><span class=\"glyphicon glyphicon-cog\"></span> {{ \'BUSCADOR.TITULO\' |\n        translate }}</h3> --><!-- <hr> --><form id=form-naves><div class=\"form-group text-center\"><label class=text-primary>{{ \'BUSCADOR.REGIMEN\' | translate }}</label><br><div class=\"btn-group btn-group-justified\" role=group><label class=\"btn btn-primary\" ng-model=buscador.filters.operacion uib-btn-radio=\"\'alquiler\'\" ng-click=buscador.operacionChecked()>{{ \'BUSCADOR.ALQUILER\' | translate }}</label><label class=\"btn btn-primary\" ng-model=buscador.filters.operacion uib-btn-radio=\"\'venta\'\" ng-click=buscador.operacionChecked()>{{ \'BUSCADOR.VENTA\' | translate }}</label></div></div><div class=\"form-group text-center form-situaciones1\"><label ng-if=\"buscador.tipo==\'nave\'\" class=text-primary>{{ \'BUSCADOR.ZONA\' | translate }}</label><label ng-if=\"buscador.tipo==\'oficina\' || buscador.tipo==\'piso\'\" class=text-primary>{{ \'BUSCADOR.POBLACION\' | translate }}</label><select id=selectSituaciones1 ng-model=buscador.situacionSelected class=\"form-control text-white btn-primary\" ng-change=\"buscador.situacionChecked(buscador.situacionSelected, true)\"><option value=none selected>- {{\'BUSCADOR.TODAS\'|translate}} -</option><option ng-if=\"option.titulo!=\'\'\" ng-repeat=\"(key, option) in buscador.situaciones\" value={{key}}>{{option.titulo}}</option></select></div><div class=\"form-group text-center\" ng-if=\"buscador.filters.situacion!=\'\'\"><label ng-if=\"buscador.tipo==\'nave\'\" class=text-primary>{{ \'BUSCADOR.POBLACION\' | translate }}</label><label ng-if=\"buscador.tipo==\'oficina\' || buscador.tipo==\'piso\'\" class=text-primary>{{ \'BUSCADOR.AREA\' | translate }}</label><div class=\"btn-group-vertical btn-block\" role=group><label class=\"btn btn-xs btn-primary\" ng-repeat=\"sit in buscador.subsituaciones\" ng-model=sit.active uib-btn-checkbox uib-btn-checkbox-true=\"\'{{sit.id}}\'\" uib-btn-checkbox-false=\"\'\'\" ng-change=buscador.subsituacionChecked()>{{sit.titulo}}</label></div></div><div class=\"form-group text-center\"><label class=text-primary>{{ \'BUSCADOR.TIPO_INMUEBLE\' | translate }}</label><br><div class=\"btn-group-vertical btn-block\" role=group><label ng-repeat=\"tipo in buscador.subtipos\" class=\"btn btn-primary\" ng-model=tipo.active uib-btn-checkbox uib-btn-checkbox-true=true uib-btn-checkbox-false=false ng-change=buscador.subtipoChecked(tipo)>{{tipo.titulo[lang]}}</label></div></div><div class=\"form-group text-center\" style=overflow:hidden><label class=text-primary>{{ \'BUSCADOR.SUPERFICIE\' | translate }}</label><br><div class=col-md-12><div class=input-group><input type=text class=form-control placeholder=\"{{ \'BUSCADOR.DE\' | translate }}\" ng-model=buscador.rangeFilters.superficie_min ng-model-options=\"{debounce: 1000}\" ng-change=buscador.changePage()> <span class=\"input-group-addon text-primary\">m<sup>2</sup></span></div></div></div><div class=\"form-group text-center\" style=overflow:hidden><div class=col-md-12><div class=input-group><input type=text class=form-control placeholder=\"{{ \'BUSCADOR.HASTA\' | translate }}\" ng-model=buscador.rangeFilters.superficie_max ng-model-options=\"{debounce: 1000}\" ng-change=buscador.changePage()> <span class=\"input-group-addon text-primary\">m<sup>2</sup></span></div></div></div><div class=\"form-group text-center\" style=overflow:hidden><label class=text-primary>{{ \'BUSCADOR.PRECIO\' | translate }}</label><br><div class=col-md-12><div class=input-group><input type=text class=form-control placeholder=\"{{ \'BUSCADOR.DE\' | translate }}\" ng-model=buscador.rangeFilters.precio_min ng-model-options=\"{debounce: 1000}\" ng-change=buscador.changePage()> <span class=\"input-group-addon text-primary\">€</span></div></div></div><div class=\"form-group text-center\" style=overflow:hidden><div class=col-md-12><div class=input-group><input type=text class=form-control placeholder=\"{{ \'BUSCADOR.HASTA\' | translate }}\" ng-model=buscador.rangeFilters.precio_max ng-model-options=\"{debounce: 1000}\" ng-change=buscador.changePage()> <span class=\"input-group-addon text-primary\">€</span></div></div></div><div class=\"form-group text-center\" ng-if=\"buscador.tipo !== \'piso\'\"><label class=text-primary>{{ \'BUSCADOR.SERVICIOS\' | translate }}</label><br><div class=\"btn-group-vertical btn-block\" role=group><label class=\"btn btn-primary\" ng-repeat=\"servicio in buscador.servicios\" ng-model=servicio.active uib-btn-checkbox uib-btn-checkbox-true=true uib-btn-checkbox-false=false ng-change=buscador.servicioChecked()>{{servicio.titulo[lang]}}</label></div></div><div class=\"form-group text-center\" ng-if=\"buscador.tipo === \'piso\'\"><label class=text-primary>{{ \'BUSCADOR.HABITACIONES\' | translate }}</label><br><select id=selectHabitaciones ng-model=buscador.rangeFilters.habitaciones_min class=\"form-control text-white btn-primary\"><option value=\"\" selected>0 {{ \'BUSCADOR.O_MAS\' | translate }}</option><option ng-repeat=\"value in [1, 2, 3, 4]\" ng-value={{value}}>{{value}} y más</option></select></div><div class=\"form-group text-center\" ng-if=\"buscador.tipo === \'piso\'\"><label class=text-primary>{{ \'BUSCADOR.BANOS\' | translate }}</label><br><select id=selectBanos ng-model=buscador.rangeFilters.banos_min class=\"form-control text-white btn-primary\"><option value=\"\" selected>0 {{ \'BUSCADOR.O_MAS\' | translate }}</option><option ng-repeat=\"value in [1, 2, 3, 4]\" ng-value={{value}}>{{value}} y más</option></select></div></form><!-- <a class=\"mapa-link text-center block\" ui-sref=\"app.mapa\" title=\"{{ \'MENU.MAPA\' | translate }}\">{{ \'MENU.MAPA\' | translate }}</a> --></div>");
$templateCache.put("app/main/admin/paginas/pagina.html","<div class=row><div class=col-md-12><h1 id=page-title>{{pagina.pagina.title.es}}</h1></div></div><hr><div class=\"alert alert-success\" ng-if=pagina.file.result.success role=alert>Guardado!</div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Imagen</h3></div><div class=panel-body><img ng-if=!pagina.file.$ngfBlobUrl ng-src={{::pagina.main_image}} class=img-responsive> <img ngf-src=pagina.file class=img-responsive> <input type=file ngf-select ng-model=pagina.file name=image required ngf-model-invalid=vm.errorFile></div></div><div class=\"panel panel-default\" ng-repeat=\"lang in pagina.languages\"><div class=panel-heading><h3 class=panel-title>{{lang|uppercase}}</h3></div><div class=panel-body><div class=form-group><label for=title-{{lang}}>Título</label><input id=title-{{lang}} type=text class=form-control ng-model=pagina.pagina.title[lang]></div><div class=form-group><label for=texto-{{lang}}>Texto</label><text-angular id=texto-{{lang}} ng-model=pagina.pagina.body[lang]></text-angular><!-- <input id=\"texto-{{lang}}\" type=\"text\" class=\"form-control\" ng-model=\"pagina.pagina.text[lang]\" /> --></div></div></div><button type=button class=\"btn btn-success\" ng-click=pagina.save() ng-disabled=pagina.saving><span ng-hide=pagina.saving>Guardar</span> <span ng-show=pagina.saving>Guardado...</span></button>");
$templateCache.put("app/main/admin/paginas/paginas.html","<h1 id=page-title>Páginas</h1><hr><div class=row><div class=col-md-12><ul class=list-group><li class=list-group-item ng-repeat=\"pagina in paginas.paginas\"><div class=row><div class=col-md-10><strong>{{pagina.title|translate}}</strong></div><div class=col-md-2><a class=\"pull-right btn btn-default btn-xs\" ui-sref=\"pagina({id: pagina.nid})\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></div></li></ul></div></div><div class=row><div class=col-md-12><ul class=list-group><li class=list-group-item ng-repeat=\"pagina in paginas.servicios\"><div class=row><div class=col-md-10><strong>{{pagina.title.es}}</strong></div><div class=col-md-2><a class=\"pull-right btn btn-default btn-xs\" ui-sref=\"pagina({id: pagina.nid})\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></div></li></ul></div></div>");
$templateCache.put("app/main/admin/slider/slide.html","<div class=row><div class=col-md-12><h1 id=page-title>Slide</h1></div></div><hr><div class=\"alert alert-success\" ng-if=slide.file.result.success role=alert>Guardado!</div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Imagen</h3></div><div class=panel-body><img ng-if=!slide.file.$ngfBlobUrl ng-src={{::slide.slide.image}} class=img-responsive> <img ngf-src=slide.file class=img-responsive> <input type=file ngf-select ng-model=slide.file name=image required ngf-model-invalid=vm.errorFile></div></div><div class=\"panel panel-default\" ng-repeat=\"lang in slide.languages\"><div class=panel-heading><h3 class=panel-title>{{lang|uppercase}}</h3></div><div class=panel-body><div class=form-group><label for=title-{{lang}}>Título</label><input id=title-{{lang}} type=text class=form-control ng-model=slide.slide.title[lang]></div><div class=form-group><label for=texto-{{lang}}>Texto</label><input id=texto-{{lang}} type=text class=form-control ng-model=slide.slide.text[lang]></div></div></div><button type=button class=\"btn btn-success\" ng-click=slide.save() ng-disabled=slide.saving><span ng-hide=slide.saving>Guardar</span> <span ng-show=slide.saving>Guardado...</span></button>");
$templateCache.put("app/main/admin/slider/slider.html","<h1 id=page-title>Slider</h1><hr><div class=row><div class=col-md-12><h3>Naves y oficinas</h3><ul class=list-group><li class=list-group-item ng-repeat=\"slide in slider.slides.naves\"><div class=row><div class=col-md-2><div><img ng-src={{slider.img_url}}{{slide.image}} class=img-responsive></div></div><div class=col-md-8><strong>{{slide.title.es}}</strong><p>{{slide.text.es}}</p></div><div class=col-md-2><a class=\"pull-right btn btn-default btn-sm\" ui-sref=\"slide({id: $index, tipo: \'naves\'})\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></div></li></ul></div></div><div class=row><div class=col-md-12><h3>Residencial</h3><ul class=list-group><li class=list-group-item ng-repeat=\"slide in slider.slides.pisos\"><div class=row><div class=col-md-2><div><img ng-src={{slider.img_url}}{{slide.image}} class=img-responsive></div></div><div class=col-md-8><strong>{{slide.title.es}}</strong><p>{{slide.text.es}}</p></div><div class=col-md-2><a class=\"pull-right btn btn-default btn-sm\" ui-sref=\"slide({id: $index, tipo: \'pisos\'})\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></div></li></ul></div></div>");}]);